import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import './Userglucose.css';
import { LineChart, BarChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, ReferenceArea } from 'recharts';
import moment from 'moment';
import Loader from '../Loader/Loader';
import { Select } from '@mantine/core';
import React from "react";
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import 'moment-timezone';
import { Password, Snowflake } from 'tabler-icons-react';
import { useLocation } from 'react-router-dom';
import AGPChart from '../AGPChart/AGPChart';
import DailyGlucoseProfiles from '../DailyGlucoseProfiles/DailyGlucoseProfiles';
import { getUserTimezone } from '../../utils/timezoneUtils';
import { useGlucoseTargets } from '../../hooks/useGlucoseTargets';
// Inline meal icon (from meal2.svg) - allows color control via fill prop
const MealIcon = ({ size = 20, fill = '#E65100', style, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 512 512" fill="none" style={style} {...props}>
    <path fill={fill} d="M376.045,261.869c27.901,9.934,56.302-34.608,91.05-106.127c32.594-67.088,45.64-103.261,37.008-128.182c-8.616-24.937-34.658-8.238-44.322,3.726c-9.656,11.974-114.333,140.843-127.404,157.435l-65.114,77.939l-52.913-63.329c-7.878-9.746-5.372-21.571-3.472-32.938c3.374-20.228,3.112-56.556-20.113-84.417c-23.225-27.844-77.751-75.638-82.96-80.617c-5.208-4.979-13.283-7.812-19.867-2.506c-6.585,5.291-3.702,11.596,1.49,18.016l66.515,82.403c5.666,7.026,4.75,13.266-0.77,17.739c-5.045,4.061-13.644,4.127-17.64-0.819L68.94,35.217c-5.569-6.912-15.151-6.453-20.752-1.933c-5.602,4.521-8.059,13.775-2.49,20.703l68.595,84.974c3.996,4.946,2.112,13.332-2.932,17.394c-5.52,4.471-11.826,4.029-17.494-2.981L27.353,70.973c-5.176-6.437-10.728-10.565-17.313-5.258c-6.568,5.323-5.487,13.808-1.719,19.95c3.767,6.142,38.982,69.528,61.289,98.11c22.325,28.565,57.769,36.508,78.259,37.475c11.514,0.54,23.602,0.573,31.464,10.335l56.59,72.583L112.614,451.767c-4.504,5.388-6.65,12.349-5.962,19.326c0.688,6.978,4.136,13.398,9.598,17.788l3.341,2.703c5.454,4.398,12.448,6.429,19.409,5.618c6.969-0.802,13.332-4.356,17.632-9.893L267.264,344.37l122.85,157.566c4.308,5.503,10.646,9.074,17.624,9.893c6.96,0.802,13.954-1.229,19.409-5.635l3.341-2.686c5.454-4.406,8.91-10.826,9.599-17.788c0.688-6.994-1.474-13.938-5.963-19.327L298.482,304.028l31.816-41.112C338.169,253.155,360.534,256.349,376.045,261.869z"/>
  </svg>
);

// Inline exercise icon (from exercise.svg) - allows color control via fill prop
const ExerciseIcon = ({ size = 20, fill = '#3245BD', style, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" style={style} {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.73926 13.1057C7.80833 13.0875 7.88094 13.0873 7.95011 13.1051C8.01928 13.123 8.0827 13.1584 8.13426 13.2078L9.48801 14.5062C9.5431 14.5591 9.58257 14.6261 9.60212 14.7C9.62167 14.7739 9.62054 14.8517 9.59885 14.9249L9.30343 15.9224C9.22975 16.1714 9.08033 16.3914 8.87593 16.5516L6.94135 18.0666C6.81231 18.1697 6.66413 18.2462 6.50536 18.2916C6.34659 18.3371 6.18038 18.3507 6.01634 18.3316C5.8523 18.3124 5.69367 18.261 5.54963 18.1802C5.40558 18.0994 5.27898 17.9908 5.17713 17.8608C5.07528 17.7308 5.0002 17.5819 4.95624 17.4227C4.91227 17.2635 4.90029 17.0972 4.92098 16.9333C4.94168 16.7695 4.99464 16.6114 5.0768 16.4681C5.15896 16.3248 5.2687 16.1993 5.39968 16.0987L7.0201 14.8295L7.44635 13.3899C7.4667 13.3214 7.50433 13.2593 7.55563 13.2095C7.60693 13.1597 7.67017 13.124 7.73926 13.1057ZM8.05093 14.2824L7.78093 15.1937C7.75634 15.2766 7.70654 15.3499 7.63843 15.4032L5.91343 16.7549C5.82939 16.824 5.77571 16.9232 5.76387 17.0314C5.75202 17.1396 5.78295 17.248 5.85005 17.3337C5.91714 17.4193 6.01508 17.4754 6.12292 17.4898C6.23077 17.5042 6.33997 17.4758 6.42718 17.4107L8.36176 15.8953C8.43003 15.842 8.47998 15.7688 8.50468 15.6857L8.72801 14.9316L8.05093 14.2824ZM11.6668 5.00033C11.9983 5.00033 12.3162 4.86863 12.5506 4.63421C12.7851 4.39979 12.9168 4.08185 12.9168 3.75033C12.9168 3.4188 12.7851 3.10086 12.5506 2.86644C12.3162 2.63202 11.9983 2.50033 11.6668 2.50033C11.3352 2.50033 11.0173 2.63202 10.7829 2.86644C10.5485 3.10086 10.4168 3.4188 10.4168 3.75033C10.4168 4.08185 10.5485 4.39979 10.7829 4.63421C11.0173 4.86863 11.3352 5.00033 11.6668 5.00033ZM11.6668 5.83366C12.2193 5.83366 12.7492 5.61417 13.1399 5.22346C13.5306 4.83276 13.7501 4.30286 13.7501 3.75033C13.7501 3.19779 13.5306 2.66789 13.1399 2.27719C12.7492 1.88649 12.2193 1.66699 11.6668 1.66699C11.1142 1.66699 10.5843 1.88649 10.1936 2.27719C9.80292 2.66789 9.58343 3.19779 9.58343 3.75033C9.58343 4.30286 9.80292 4.83276 10.1936 5.22346C10.5843 5.61417 11.1142 5.83366 11.6668 5.83366Z" fill={fill}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M9.05727 5.98569C9.65227 5.76486 10.2914 5.77736 10.8652 6.07444C11.411 6.35652 11.7806 6.83402 12.0131 7.33319C12.1006 7.52027 12.1806 7.69444 12.256 7.85777C12.4394 8.25527 12.5894 8.58152 12.7331 8.86611C12.9356 9.26902 13.0839 9.50527 13.2148 9.65777C13.3273 9.78819 13.4235 9.85444 13.5477 9.90277C13.6935 9.96027 13.9323 10.0124 14.3569 10.0253C14.6626 10.0385 14.9509 10.1717 15.1592 10.3958C15.3675 10.62 15.4792 10.9172 15.4701 11.2231C15.4609 11.5291 15.3317 11.8191 15.1103 12.0304C14.889 12.2417 14.5933 12.3574 14.2873 12.3524C13.7219 12.3357 13.1898 12.2632 12.7002 12.0719C12.1885 11.8719 11.7848 11.5665 11.4481 11.174C11.4081 11.1274 11.3692 11.0799 11.3314 11.0315L11.1635 11.9082L12.9831 13.7036C13.0994 13.8178 13.1898 13.9553 13.2494 14.1069L14.2844 16.7444C14.3402 16.8868 14.3675 17.0387 14.3646 17.1915C14.3617 17.3444 14.3288 17.4952 14.2676 17.6353C14.2064 17.7754 14.1183 17.9021 14.0082 18.0082C13.8981 18.1142 13.7681 18.1976 13.6258 18.2534C13.4835 18.3092 13.3316 18.3365 13.1787 18.3336C13.0259 18.3307 12.8751 18.2978 12.7349 18.2366C12.5948 18.1755 12.4681 18.0873 12.3621 17.9772C12.256 17.8671 12.1727 17.7372 12.1169 17.5949L11.1719 15.1878L7.89727 11.9565C7.77177 11.8327 7.67603 11.682 7.61727 11.5158C7.55852 11.3495 7.53829 11.1721 7.55811 10.9969L7.69352 9.80111C7.32186 10.2815 7.00936 10.8594 6.79102 11.5428C6.69715 11.8369 6.49026 12.0818 6.21587 12.2234C5.94148 12.365 5.62207 12.3919 5.3279 12.298C5.03373 12.2041 4.7889 11.9972 4.64727 11.7228C4.50564 11.4484 4.47881 11.129 4.57269 10.8349C5.30936 8.52736 6.97561 6.78944 9.04352 5.99111L9.04602 5.98986L9.05727 5.98569ZM9.34894 6.76652L9.34227 6.76902C7.51602 7.47444 6.02811 9.01527 5.36686 11.0882C5.35364 11.1296 5.34871 11.1732 5.35234 11.2165C5.35597 11.2598 5.3681 11.3019 5.38802 11.3405C5.40795 11.3792 5.43529 11.4135 5.46847 11.4415C5.50166 11.4696 5.54004 11.4908 5.58144 11.504C5.62283 11.5172 5.66642 11.5222 5.70972 11.5185C5.75302 11.5149 5.79518 11.5028 5.8338 11.4829C5.87241 11.4629 5.90672 11.4356 5.93477 11.4024C5.96282 11.3692 5.98406 11.3308 5.99727 11.2894C6.41144 9.99236 7.13269 9.01111 7.9806 8.31861C8.04474 8.26627 8.12301 8.23423 8.20544 8.22657C8.28786 8.2189 8.3707 8.23596 8.44339 8.27557C8.51607 8.31517 8.57532 8.37553 8.61356 8.44895C8.6518 8.52237 8.66731 8.60551 8.6581 8.68777L8.38644 11.0907C8.38082 11.1404 8.38656 11.1908 8.40324 11.238C8.41991 11.2852 8.44707 11.328 8.48269 11.3632L11.8202 14.6565C11.8619 14.6974 11.8944 14.7465 11.9156 14.8007L12.8927 17.2907C12.908 17.3319 12.9313 17.3696 12.9614 17.4017C12.9915 17.4338 13.0276 17.4596 13.0677 17.4775C13.1079 17.4955 13.1512 17.5053 13.1951 17.5063C13.2391 17.5073 13.2828 17.4996 13.3237 17.4835C13.3646 17.4675 13.4019 17.4434 13.4334 17.4128C13.465 17.3821 13.4901 17.3455 13.5073 17.305C13.5245 17.2646 13.5335 17.2211 13.5337 17.1772C13.5339 17.1332 13.5253 17.0896 13.5085 17.049L12.4735 14.4115C12.4567 14.3683 12.431 14.3292 12.3981 14.2965L10.4198 12.3449C10.371 12.2968 10.3348 12.2374 10.3145 12.172C10.2941 12.1066 10.2902 12.0371 10.3031 11.9699L10.7119 9.83444C10.728 9.7495 10.7703 9.67171 10.8326 9.61184C10.895 9.55197 10.9745 9.51299 11.06 9.50031C11.1456 9.48763 11.2329 9.50187 11.31 9.54106C11.3871 9.58025 11.45 9.64244 11.4902 9.71902C11.6777 10.0761 11.8652 10.3815 12.0802 10.6315C12.3369 10.9303 12.6306 11.1499 13.0035 11.2957C13.3702 11.439 13.7973 11.504 14.3119 11.5194C14.3558 11.5216 14.3997 11.515 14.441 11.4999C14.4823 11.4849 14.5202 11.4618 14.5525 11.432C14.5848 11.4022 14.6108 11.3662 14.6291 11.3262C14.6473 11.2862 14.6574 11.2429 14.6587 11.199C14.66 11.1551 14.6526 11.1113 14.6368 11.0703C14.621 11.0292 14.5972 10.9917 14.5668 10.96C14.5364 10.9283 14.4999 10.9029 14.4596 10.8855C14.4192 10.868 14.3758 10.8587 14.3319 10.8582C13.8569 10.844 13.5135 10.7844 13.2444 10.679C12.9819 10.5765 12.7752 10.4249 12.5827 10.2003C12.3844 9.96986 12.2002 9.66111 11.9889 9.24111C11.8208 8.90076 11.6583 8.55765 11.5014 8.21194L11.4994 8.20694C11.4244 8.04361 11.3444 7.87027 11.2577 7.68486C11.0785 7.30069 10.8202 6.98902 10.4827 6.81444C10.1377 6.63611 9.74561 6.61944 9.34894 6.76652Z" fill={fill}/>
  </svg>
);
// Pill icon for non-insulin medication
const PillIcon = ({ size = 20, fill = '#F0206B', style, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 36 36" fill="none" style={style} {...props}>
    <path d="M15.2863 1.92871C13.3245 1.96176 11.5527 3.13176 10.7511 4.9409L20.3488 7.83988C20.7706 5.3234 19.2589 2.88355 16.8261 2.14316C16.3902 2.01098 15.9331 1.93855 15.4761 1.92871H15.2863ZM10.3855 6.15309C9.95657 8.6766 11.4683 11.1235 13.9081 11.8618C16.355 12.6 18.9636 11.3907 19.9902 9.04926L10.3855 6.15309ZM29.0534 9.26723C27.2745 9.27426 25.3831 10.1321 23.9558 12.15L15.1808 24.5883C12.8253 27.9211 13.8519 31.4086 16.1722 33.0539C18.4995 34.7063 22.1206 34.5164 24.4761 31.1836L33.2441 18.7524C35.5995 15.4125 34.573 11.9321 32.2527 10.2797C31.3808 9.66098 30.3331 9.30238 29.2292 9.26723H29.0534ZM28.9269 10.4836C29.0183 10.4836 29.1097 10.4836 29.1941 10.4907C30.0449 10.5258 30.8464 10.8282 31.5214 11.3133C33.3284 12.593 34.2355 15.1454 32.2034 18.0211L27.6683 24.4547C25.1511 23.7797 21.9167 21.4805 20.4472 19.3219L24.9964 12.8813C26.1847 11.2008 27.598 10.5118 28.9269 10.4836ZM6.41633 15.8414C5.73993 15.8485 5.07266 15.9891 4.45251 16.2633C2.12446 17.2829 0.912974 19.8844 1.62313 22.3313L10.8144 18.3164C9.89329 16.7625 8.21985 15.8204 6.41633 15.8414ZM11.3136 19.4696L2.12376 23.4914C3.42102 25.6993 6.15266 26.5852 8.49407 25.5657C10.8284 24.5391 12.0378 21.9235 11.3136 19.4696Z" fill={fill}/>
  </svg>
);

// Syringe icon for insulin
const SyringeIcon = ({ size = 20, fill = '#9C27B0', style, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={style} {...props}>
    <path d="M11.15 15.18L9.73 13.77L11.15 12.35L12.56 13.77L13.97 12.35L12.56 10.94L13.97 9.53L15.39 10.94L16.8 9.53L13.97 6.7L6.14 14.53L8.97 17.36L11.15 15.18ZM17.62 3.22L20.84 6.44L19.07 8.21L15.85 5L17.62 3.22ZM17.62 1.81L14.44 5L3.14 16.31L3.03 16.42L2 21.06L3 22.06L7.58 21.08L18.97 9.68L22.25 6.44L17.62 1.81Z" fill={fill}/>
  </svg>
);

//let now = dayjs();


var data = [{ value: '1', label: 'Monday' }, { value: '2', label: 'Tuesday' }, { value: '3', label: 'Wednesday' }, { value: '4', label: 'Thursday' }, { value: '5', label: 'Friday' }, { value: '6', label: 'Saturday' }, { value: '7', label: 'Sunday' }];

const base_url = process.env.REACT_APP_BASE_URL;

// 15-day overlay chart: rainbow gradient (oldest→newest)
const OVERLAY_COLORS = [
  '#E53935', '#EF5350', '#FB8C00', '#FFA726', '#FDD835', '#C0CA33',
  '#43A047', '#00ACC1', '#039BE5', '#1E88E5', '#3949AB', '#5E35B1',
  '#7B1FA2', '#AD1457', '#C62828'
];

// Format hour (0-24, can be fractional) for overlay chart X axis and tooltip
const formatOverlayHour = (hour) => {
  const h = Math.floor(hour % 24);
  const m = Math.round((hour % 1) * 60);
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  const ampm = h < 12 ? 'am' : 'pm';
  return m === 0 ? `${hour12}${ampm}` : `${hour12}:${m.toString().padStart(2, '0')}${ampm}`;
};

// Return glucose values - filter out bad CGM readings (outside 36-450 mg/dL range)
const clampGlucose = (value) => {
  if (value === null || value === undefined || isNaN(value)) return null;
  if (value < 36 || value > 450) return null;
  return value;
};

// Helper to get local day name from a date string (handles UTC date strings properly)
// API returns dates like "2026-01-16" which represent UTC dates
const getLocalDayName = (dateStr, format = 'ddd') => {
  if (!dateStr) return '';
  // Parse as local date (not UTC) to avoid timezone shift issues
  // For date-only strings like "2026-01-16", treat as local date
  const localDate = moment(dateStr, 'YYYY-MM-DD');
  return localDate.format(format);
};

// Helper to format UTC timestamp to local time
const formatTimestampLocal = (timestamp, format = 'ddd') => {
  if (!timestamp) return '';
  // Parse UTC timestamp and convert to local
  return moment.utc(timestamp).local().format(format);
};

// Helper: Convert UTC timestamp to local moment
const toLocalTime = (timestamp) => moment.utc(timestamp).local();

// Helper: Get UTC date string for start of a local day
// This accounts for timezone offset when querying the backend
const getUTCDateForLocalDayStart = (localDate) => {
  return moment(localDate).startOf('day').utc().format('YYYY-MM-DD');
};

// Helper: Get UTC date string for end of a local day  
const getUTCDateForLocalDayEnd = (localDate) => {
  return moment(localDate).endOf('day').utc().format('YYYY-MM-DD');
};

function Userglucose() {

  const DATE = localStorage.getItem("DATE");
  // Use current time as end point for "Last 24 hours" view
  // This avoids showing blank space for future times that haven't happened yet
  // If selected DATE is today, end at current time; otherwise end at end of that day
  const isToday = moment(DATE).isSame(moment(), 'day');
  let ct = isToday ? moment().format() : moment(DATE).endOf('day').format();
  let past_ct = isToday 
    ? moment().subtract(24, "hours").startOf('hour').format()
    : moment(DATE).endOf('day').subtract(24, "hours").startOf('hour').format();
  let timeArray = [];

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const UID = queryParams.get("user");
  
  // Track the user we're currently showing data for
  const [dataForUID, setDataForUID] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [deviceBootAt, setDeviceBootAt] = useState(localStorage.getItem("deviceBootAt") || null);

  // Watch for deviceBootAt changes in localStorage
  useEffect(() => {
    const checkDeviceDates = () => {
      const stored = localStorage.getItem("deviceBootAt");
      if (stored && stored !== deviceBootAt) {
        setDeviceBootAt(stored);
      }
    };
    const interval = setInterval(checkDeviceDates, 500);
    return () => clearInterval(interval);
  }, [deviceBootAt]);
  
  // Reset all data when UID changes
  useEffect(() => {
    if (UID && dataForUID && UID !== dataForUID) {
      // Clear all cached data
      setFasting([]);
      setGmi([]);
      setRange([]);
      setGChart([]);
      setwChart([]);
      setrangeAve([]);
      setExrtarange([]);
      setrangeAveDay([]);
      setGlucoseChartData([]);
      setOverlayChartData([]);
      setOverlayDayKeys([]);
      setSelectedOverlayDays(new Set());
      setMealRecords24h([]);
      setExerciseRecords24h([]);
      setMedicationRecords24h([]);
      setInfluxRangeScoreData([]);
      setInfluxExtraRangeData([]);
      setInfluxFastingData([]);
      setInfluxDailyAvgData([]);
      setInfluxGmiData([]);
      setInfluxDayDetailsData([]);
      setFilteredGlucose([]);
      setfastArr([]);
      setrangArr([]);
      setGchartArr([]);
      setwchartArr([]);
      setwchartArr1([]);
      setforty([]);
      setforty1([]);
      setextrarangeF([]);
      
      // Reset loading flags to trigger refetch
      dataLoading(false);
      dataLoading1(false);
      dataLoading2(false);
      dataLoading3(false);
      dataLoading4(false);
      dataLoading5(false);
      dataLoading6(false);
      dataLoading7(false);
      
      // Reset other tracking state
      setinit(false);
      setinit1(false);
      setinit3(false);
      setinit4(false);
      setinit5(false);
      setinit6(false);
      setinit7(false);
      setinitapiload(true);
      setLastFetchedEmail(null);
      setLastFetchedDate(null);
      setUserEmail(null);
      setDataForUID(null);
    }
  }, [UID]);
  
  // Watch for email changes in localStorage (set by User.js after profile loads)
  // Only accept email if it matches the current UID's profile
  useEffect(() => {
    const checkEmail = () => {
      const currentEmail = localStorage.getItem("email");
      const storedUID = localStorage.getItem("UID")?.replace(/['"]+/g, '');
      
      // Only update email if localStorage UID matches our current UID
      // This prevents race condition where old email is still in localStorage
      if (currentEmail && storedUID === UID && currentEmail !== userEmail) {
        setUserEmail(currentEmail);
      }
    };
    
    // Check immediately and then periodically until we have an email
    checkEmail();
    const interval = setInterval(checkEmail, 300);
    
    return () => clearInterval(interval);
  }, [userEmail, UID]);
  
  const [graphData, setGraphData] = useState(null);
  const [loadingGraph, setLoadingGraph] = useState(true);

  useEffect(() => {
    async function fetchGraphData() {
      try {
        const response = await axios.post(
          process.env.REACT_APP_BASE_URL + '/graph/get-graph-data',
          { uuid: UID },
          { headers: { "Authorization": `Bearer ${localStorage.getItem("user").replace(/['"]+/g, '')}` } }
        );
        setGraphData(response.data.response);
      } catch (error) {
        setGraphData(null);
      } finally {
        setLoadingGraph(false);
      }
    }
    if (UID) fetchGraphData();
  }, [UID]);

  const [fasting, setFasting] = useState([]);
  const [gmi, setGmi] = useState([]);
  const [range, setRange] = useState([]);
  const [gchart, setGChart] = useState([]);
  const [wchart, setwChart] = useState([]);
  const [rangeAve, setrangeAve] = useState([]);
  const [Extrarange, setExrtarange] = useState([]);
  const [rangeAveDay, setrangeAveDay] = useState([]);
  const [loaded, dataLoading] = useState(false);
  const [loaded1, dataLoading1] = useState(false);
  const [loaded2, dataLoading2] = useState(false);
  const [loaded3, dataLoading3] = useState(false);
  const [loaded4, dataLoading4] = useState(false);
  const [loaded5, dataLoading5] = useState(false);
  const [loaded6, dataLoading6] = useState(false);
  const [loaded7, dataLoading7] = useState(false);

  const user = localStorage.getItem("user").replace(/['"]+/g, '');

  // Local date values (for display/logic purposes)
  const startDay = moment(DATE).subtract(24, 'hours').format('YYYY-MM-DD');
  const endDay = moment(DATE).format('YYYY-MM-DD');
  const startDay1 = moment(DATE).subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
  const endDay1 = moment(DATE).endOf('isoWeek').format('YYYY-MM-DD');
  const startDay3 = moment(DATE).subtract(2, 'days').format('YYYY-MM-DD');
  const endDay3 = moment(DATE).format('YYYY-MM-DD');
  const startDay4 = moment(DATE).subtract(6, 'days').format('YYYY-MM-DD');
  const startDay6 = moment(DATE).format('YYYY-MM-DD');
  //const [startDay7 , setstartDay7] = useState(endDay3);

  // UTC-adjusted date ranges for InfluxDB queries
  // These account for timezone offset so evening readings aren't attributed to the next day
  const startDay3UTC = getUTCDateForLocalDayStart(moment(DATE).subtract(2, 'days'));
  const endDay3UTC = getUTCDateForLocalDayEnd(moment(DATE));

  const mealch = { "uuid": UID, "start_date": startDay, "end_date": endDay, "is_admin": 'True' }
  const mealch1 = { "uuid": UID, "start_date": startDay1, "end_date": endDay1, "is_admin": 'True' }
  const mealch2 = { "uuid": UID, "start_date": startDay, "end_date": endDay, "is_admin": 'True' }
  const mealch3 = { "uuid": UID, "email": userEmail, "start_date": startDay3UTC, "end_date": endDay3UTC, "is_admin": 'True' }
  const mealch4 = { "uuid": UID, "start_date": startDay4, "end_date": endDay1 }
  const mealch5 = { "uuid": UID, "start_date": startDay1, "end_date": endDay1, 'is_one_day': false }
  const mealch6 = { "uuid": UID, "start_date": startDay, "end_date": endDay1, 'is_one_day': true }


  const [initialapiload, setinitapiload] = useState(true)
  const { lower_range: targetLower, upper_range: targetUpper } = useGlucoseTargets(UID)
  
  // Debug: log the target values
  console.log('[Userglucose] Target ranges:', { targetLower, targetUpper, UID });

  const [glucoseChartData, setGlucoseChartData] = useState([]);
  const [loadingWeeklyData, setLoadingWeeklyData] = useState(false);
  const [overlayChartData, setOverlayChartData] = useState([]);
  const [overlayDayKeys, setOverlayDayKeys] = useState([]);
  const [selectedOverlayDays, setSelectedOverlayDays] = useState(new Set());
  const [mealRecords24h, setMealRecords24h] = useState([]);
  const [exerciseRecords24h, setExerciseRecords24h] = useState([]);
  const [medicationRecords24h, setMedicationRecords24h] = useState([]);
  const [brushRange24h, setBrushRange24h] = useState({ startIndex: 0, endIndex: null });
  const [influxRangeScoreData, setInfluxRangeScoreData] = useState([]); // Time in Range calculated from InfluxDB data
  const [influxExtraRangeData, setInfluxExtraRangeData] = useState([]); // Below/Above range data from InfluxDB
  const [influxFastingData, setInfluxFastingData] = useState([]); // Fasting glucose from InfluxDB
  const [influxDailyAvgData, setInfluxDailyAvgData] = useState([]); // Daily average from InfluxDB
  const [influxGmiData, setInfluxGmiData] = useState([]); // GMI calculated from InfluxDB data
  const [influxDayDetailsData, setInfluxDayDetailsData] = useState([]); // 3-hour averages for selected day
  const [loadingDayDetails, setLoadingDayDetails] = useState(false);
  const [loadingInfluxRange, setLoadingInfluxRange] = useState(false);
  
  // GMI calculation: GMI(%) = 3.31 + (0.02392 × mean glucose in mg/dL)
  const calculateGMI = (glucoseMgdl) => {
    if (glucoseMgdl === null || glucoseMgdl === undefined) return null;
    const gmi = 3.31 + (0.02392 * glucoseMgdl);
    return Math.round(gmi * 10) / 10;
  };
  const [lastFetchedEmail, setLastFetchedEmail] = useState(null); // Track which email we last fetched for
  const [lastFetchedDate, setLastFetchedDate] = useState(null); // Track which date we last fetched for
  const [lastFetchedBootAt, setLastFetchedBootAt] = useState(null); // Track which device boot we last fetched for

  const avgTimeInRange = useMemo(() => {
    const today = moment().format('YYYY-MM-DD');
    const valid = influxRangeScoreData.filter(d => d.range_score != null && d.date && d.date <= today);
    const withData = valid.filter(d => d.range_score > 0 || valid.some(v => v.date === d.date));
    // Only include days that have actual readings (exclude future days where range_score is 0 due to no data)
    const daysWithReadings = influxRangeScoreData.filter(d => d.date && d.date <= today && d.range_score !== 0);
    // Also include days at 0% that are in the past (truly 0% TIR is possible but rare)
    if (!daysWithReadings.length) return null;
    return Math.round(daysWithReadings.reduce((sum, d) => sum + d.range_score, 0) / daysWithReadings.length);
  }, [influxRangeScoreData]);

  const avgExtraRange = useMemo(() => {
    const today = moment().format('YYYY-MM-DD');
    // Extra range data doesn't have a date field, use index to compare with dayLabels
    const validBelow = influxExtraRangeData.filter((d, i) => {
      const dayLabel = d.day;
      const matchingRange = influxRangeScoreData.find(r => r.day === dayLabel);
      return matchingRange && matchingRange.date && matchingRange.date <= today && matchingRange.range_score !== undefined;
    });
    // Only include days that are not in the future and have data
    const pastWithData = validBelow.filter((d, i) => {
      const dayLabel = d.day;
      const matchingRange = influxRangeScoreData.find(r => r.day === dayLabel);
      return matchingRange && matchingRange.range_score !== 0;
    });
    if (!pastWithData.length) return { below: null, above: null };
    const avgBelow = Math.round(pastWithData.reduce((s, d) => s + (d.cat_70 || 0), 0) / pastWithData.length);
    const avgAbove = Math.round(pastWithData.reduce((s, d) => s + (d.cat_180 || 0), 0) / pastWithData.length);
    return { below: avgBelow, above: avgAbove };
  }, [influxExtraRangeData, influxRangeScoreData]);

  const avgFasting = useMemo(() => {
    const valid = influxFastingData.filter(d => d.blood_glucose_mg_per_dL != null && d.blood_glucose_mg_per_dL > 0);
    if (!valid.length) return null;
    return Math.round(valid.reduce((sum, d) => sum + d.blood_glucose_mg_per_dL, 0) / valid.length);
  }, [influxFastingData]);

  const avgDailyGlucose = useMemo(() => {
    const valid = influxDailyAvgData.filter(d => d.glucose_avg != null);
    if (!valid.length) return null;
    return Math.round(valid.reduce((sum, d) => sum + d.glucose_avg, 0) / valid.length);
  }, [influxDailyAvgData]);

  const avgGmi = useMemo(() => {
    const valid = influxGmiData.filter(d => d.gmi != null && d.gmi > 0);
    if (!valid.length) return null;
    return (valid.reduce((sum, d) => sum + d.gmi, 0) / valid.length).toFixed(1);
  }, [influxGmiData]);

  // Fetch Time in Range data from InfluxDB on component mount
  // Backend now handles timezone conversion, so we send LOCAL dates + timezone
  const fetchInfluxTimeInRange = async () => {
    if (!UID || !userEmail) return;
    
    setLoadingInfluxRange(true);
    // Use device boot/expire dates if available, otherwise fall back to 15-day window from DATE
    const deviceBootAt = localStorage.getItem("deviceBootAt");
    const deviceExpireAt = localStorage.getItem("deviceExpireAt");
    
    let rangeStart, rangeEnd, rangeStartLocal;
    if (deviceBootAt && deviceExpireAt) {
      rangeStartLocal = moment.unix(parseInt(deviceBootAt));
      rangeStart = rangeStartLocal.format('YYYY-MM-DD');
      rangeEnd = moment.unix(parseInt(deviceExpireAt)).format('YYYY-MM-DD');
    } else {
      rangeStartLocal = moment(DATE).subtract(14, 'days');
      rangeStart = rangeStartLocal.format('YYYY-MM-DD');
      rangeEnd = moment(DATE).format('YYYY-MM-DD');
    }
    
    // Build ordered array of day labels for chart X-axes
    const totalDays = moment(rangeEnd).diff(moment(rangeStart), 'days') + 1;
    const dayLabels = [];
    for (let i = 0; i < totalDays; i++) {
      dayLabels.push(moment(rangeStartLocal).add(i, 'days').format('M/D'));
    }
    
    // Get user's timezone
    const userTimezone = getUserTimezone();
    
    try {
      // Backend now accepts timezone parameter and returns timestamps in user's local time
      const response = await axios.post(
        base_url + '/admin/influxdb/glucose-data?aggregate=15min',
        {
          uuid: UID,
          email: userEmail,
          start_date: rangeStart,  // Local date
          end_date: rangeEnd,      // Local date
          timezone: userTimezone,
          is_admin: 'True'
        },
        { headers: { "Authorization": `Bearer ${user}` } }
      );
      
      if (response.data.response !== "Error while fetching data") {
        const cgmData = response.data.response?.cgm_data || [];
        
        // Group readings by LOCAL day (backend already converted)
        const readingsByLocalDay = {};
        dayLabels.forEach((dayLabel, index) => {
          const localDayStart = moment(rangeStartLocal).add(index, 'days').startOf('day');
          const localDayEnd = moment(rangeStartLocal).add(index, 'days').endOf('day');
          
          const dayReadings = cgmData.filter(reading => {
            const timestamp = reading.timestamp || reading.time || reading._time;
            if (!timestamp) return false;
            const localTime = moment(timestamp);
            return localTime.isSameOrAfter(localDayStart) && localTime.isSameOrBefore(localDayEnd);
          });
          
          readingsByLocalDay[dayLabel] = {
            readings: dayReadings,
            localDate: localDayStart.format('YYYY-MM-DD')
          };
        });
        
        // Calculate Time in Range for each day in the 15-day window
        const rangeScoreData = dayLabels.map(dayLabel => {
          const { readings, localDate } = readingsByLocalDay[dayLabel];
          if (readings.length === 0) {
            return { day: dayLabel, range_score: 0, date: localDate };
          }
          
          const inRangeCount = readings.filter(r => {
            const glucose = r.glucose_avg || r.glucose || r.value;
            return glucose >= targetLower && glucose <= targetUpper;
          }).length;
          
          const rangePercent = (inRangeCount / readings.length) * 100;
          return {
            day: dayLabel,
            range_score: Math.round(rangePercent * 10) / 10,
            date: localDate
          };
        });
        
        setInfluxRangeScoreData(rangeScoreData);
        
        // Calculate below/above range percentages for each day
        const extraRangeData = dayLabels.map(dayLabel => {
          const { readings } = readingsByLocalDay[dayLabel];
          if (readings.length === 0) {
            return { day: dayLabel, cat_70: 0, cat_180: 0 };
          }
          
          const belowCount = readings.filter(r => {
            const glucose = r.glucose_avg || r.glucose || r.value;
            return glucose < targetLower;
          }).length;
          
          const aboveCount = readings.filter(r => {
            const glucose = r.glucose_avg || r.glucose || r.value;
            return glucose > targetUpper;
          }).length;
          
          return {
            day: dayLabel,
            cat_70: Math.round((belowCount / readings.length) * 1000) / 10,
            cat_180: Math.round((aboveCount / readings.length) * 1000) / 10
          };
        });
        setInfluxExtraRangeData(extraRangeData);
        
        // Calculate fasting glucose (earliest reading between 4-7 AM local time) for each day
        const fastingData = dayLabels.map(dayLabel => {
          const { readings } = readingsByLocalDay[dayLabel];
          
          const fastingReadings = readings.filter(r => {
            const timestamp = r.timestamp || r.time || r._time;
            const localHour = moment(timestamp).hour();
            return localHour >= 4 && localHour < 7;
          }).sort((a, b) => {
            const timeA = a.timestamp || a.time || a._time;
            const timeB = b.timestamp || b.time || b._time;
            return moment(timeA).valueOf() - moment(timeB).valueOf();
          });
          
          const fastingReading = fastingReadings[0];
          return {
            day: dayLabel,
            blood_glucose_mg_per_dL: fastingReading ? (fastingReading.glucose_avg || fastingReading.glucose || 0) : 0,
            fasting_time: fastingReading ? (fastingReading.timestamp || fastingReading.time) : null
          };
        });
        setInfluxFastingData(fastingData);
        
        // Calculate daily averages for each day
        const dailyAvgData = dayLabels.map(dayLabel => {
          const { readings, localDate } = readingsByLocalDay[dayLabel];
          if (readings.length === 0) {
            return { date: localDate, day: dayLabel, glucose_avg: null, glucose_min: null, glucose_max: null };
          }
          
          const glucoseValues = readings
            .map(r => r.glucose_avg || r.glucose || r.value)
            .filter(v => v != null && v >= 36 && v <= 450);
          
          if (glucoseValues.length === 0) {
            return { date: localDate, day: dayLabel, glucose_avg: null, glucose_min: null, glucose_max: null };
          }
          
          const sum = glucoseValues.reduce((a, b) => a + b, 0);
          return {
            date: localDate,
            day: dayLabel,
            glucose_avg: Math.round((sum / glucoseValues.length) * 10) / 10,
            glucose_min: Math.round(Math.min(...glucoseValues) * 10) / 10,
            glucose_max: Math.round(Math.max(...glucoseValues) * 10) / 10
          };
        });
        setInfluxDailyAvgData(dailyAvgData);
        
        // Calculate GMI from daily averages
        const gmiData = dayLabels.map(dayLabel => {
          const dayAvg = dailyAvgData.find(d => d.day === dayLabel);
          return {
            day: dayLabel,
            gmi: dayAvg?.glucose_avg ? calculateGMI(dayAvg.glucose_avg) : 0
          };
        });
        setInfluxGmiData(gmiData);
        
        // Also set the glucose chart data
        const chartData = dayLabels.map(dayLabel => {
          const dayAvg = dailyAvgData.find(d => d.day === dayLabel);
          return {
            day: dayLabel,
            glucose: dayAvg?.glucose_avg ?? null
          };
        });
        setGlucoseChartData(chartData);
      }
    } catch (error) {
      console.error('Error fetching Time in Range:', error);
    } finally {
      setLoadingInfluxRange(false);
    }
  };

  // Fetch 5-minute aggregated data for a specific day and calculate 3-hour averages
  const fetchDayDetails = async (selectedDayNum) => {
    if (!UID || !userEmail) return;
    
    setLoadingDayDetails(true);
    
    // Calculate the date for the selected day of the current week
    // selectedDayNum: 1=Monday, 2=Tuesday, ... 7=Sunday
    const targetLocalDate = moment(DATE).startOf('isoWeek').add(selectedDayNum - 1, 'days');
    const targetDate = targetLocalDate.format('YYYY-MM-DD');
    const isToday = targetDate === moment().format('YYYY-MM-DD');
    const currentHour = moment().hour();
    
    // Get user's timezone
    const userTimezone = getUserTimezone();
    
    try {
      // Backend now handles timezone conversion - send LOCAL dates
      const response = await axios.post(
        base_url + '/admin/influxdb/glucose-data?aggregate=5min',
        {
          uuid: UID,
          email: userEmail,
          start_date: targetDate,   // Local date
          end_date: targetDate,     // Local date
          timezone: userTimezone,   // NEW: User's timezone
          is_admin: 'True'
        },
        { headers: { "Authorization": `Bearer ${user}` } }
      );
      
      if (response.data.response !== "Error while fetching data") {
        const cgmData = response.data.response?.cgm_data || [];
        
        // Define local day boundaries for filtering
        const localDayStart = moment(targetLocalDate).startOf('day');
        const localDayEnd = moment(targetLocalDate).endOf('day');
        
        // Define 3-hour time blocks
        const timeBlocks = [
          { time: '0to3', start: 0, end: 3 },
          { time: '3to6', start: 3, end: 6 },
          { time: '6to9', start: 6, end: 9 },
          { time: '9to12', start: 9, end: 12 },
          { time: '12to15', start: 12, end: 15 },
          { time: '15to18', start: 15, end: 18 },
          { time: '18to21', start: 18, end: 21 },
          { time: '21to24', start: 21, end: 24 }
        ];
        
        // Calculate average for each 3-hour block
        const dayDetailsData = timeBlocks.map(block => {
          // Skip future time blocks if this is today (but show current block)
          if (isToday && block.start > currentHour) {
            return { time: block.time, glucose_avg: null, isFuture: true };
          }
          
          const readings = cgmData.filter(item => {
            // Backend returns timestamps in user's local time (no Z)
            const localTime = moment(item.timestamp);
            
            // Ensure reading falls within the local day
            const dayStart = moment(targetDate).startOf('day');
            const dayEnd = moment(targetDate).endOf('day');
            if (localTime.isBefore(dayStart) || localTime.isAfter(dayEnd)) {
              return false;
            }
            
            const hour = localTime.hour();
            return hour >= block.start && hour < block.end;
          });
          
          if (readings.length === 0) {
            return { time: block.time, glucose_avg: null };
          }
          
          const sum = readings.reduce((acc, item) => acc + (item.glucose_avg || item.glucose || 0), 0);
          const avg = sum / readings.length;
          return { 
            time: block.time, 
            glucose_avg: Math.round(clampGlucose(avg) * 10) / 10 
          };
        }).filter(block => !block.isFuture); // Remove future blocks from display
        
        setInfluxDayDetailsData(dayDetailsData);
      }
    } catch (error) {
      console.error('Error fetching day details:', error);
    } finally {
      setLoadingDayDetails(false);
    }
  };

  async function getData() {
    try {
      const response = await axios({ method: "post", url: base_url + "/graph/glucose-fasting-data", data: mealch, 'Content-Type': 'application/json', crossDomain: true, headers: { "Authorization": `Bearer ${user}` } })
      if (response.data.response !== "Error while fetching data") { setFasting([response.data.response]) };
    } finally { dataLoading(true); }
  }
  async function getData1() {
    try {
      const response = await axios({ method: "post", url: base_url + "/graph/glucose-gmi-data", data: mealch1, 'Content-Type': 'application/json', crossDomain: true, headers: { "Authorization": `Bearer ${user}` } })
      if (response.data.response !== "Error while fetching data") {
        setGmi([response.data.response.sort(function (left, right) {
          return moment.utc(left.date).diff(moment.utc(right.date))
        })])
      };
    } finally { dataLoading1(true); };
  }
  async function getData2() {
    try {
      const response = await axios({ method: "post", url: base_url + "/graph/glucose-rangescore-data", data: mealch2, 'Content-Type': 'application/json', crossDomain: true, headers: { "Authorization": `Bearer ${user}` } })
      if (response.data.response !== "Error while fetching data") { setRange([response.data.response]) };

    }
    finally { dataLoading2(true); };
  }
  // Using new InfluxDB endpoint for glucose chart data (24-hour view)
  async function getData3() {
    // Guard: Don't fetch if email isn't available yet
    if (!userEmail) return;
    
    // Get user's timezone
    const userTimezone = getUserTimezone();
    
    try {
      // Backend now handles timezone conversion - send LOCAL dates
      const response = await axios({ 
        method: "post", 
        url: base_url + "/admin/influxdb/glucose-data?aggregate=15min", 
        data: { 
          ...mealch3, 
          email: userEmail,
          timezone: userTimezone  // NEW: User's timezone
        },
        'Content-Type': 'application/json', 
        crossDomain: true, 
        headers: { "Authorization": `Bearer ${user}` } 
      });
      
      if (response.data.response !== "Error while fetching data") { 
        setGChart([response.data.response.cgm_data]); 
      }
      if (response) {
        dataLoading3(true);
      }
    } catch (error) {
      console.error('Error fetching glucose data:', error);
      dataLoading3(true); // Still mark as loaded to prevent infinite retries
    }
  }
  async function getData4() {
    try {
      const response = await axios({ method: "post", url: base_url + "/graph/glucose-graph-data", data: mealch4, 'Content-Type': 'application/json', crossDomain: true, headers: { "Authorization": `Bearer ${user}` } })
      if (response.data.response !== "Error while fetching data") { setwChart([response.data.response]) };
    }
    finally { dataLoading4(true); };
  }
  async function getData5() {
    try {
      const response = await axios({ method: "post", url: base_url + "/graph/daily-glucose-average", data: mealch5, 'Content-Type': 'application/json', crossDomain: true, headers: { "Authorization": `Bearer ${user}` } })
      if (response.data.response !== "Error while fetching data") {

        setrangeAve([response.data.response.sort(function (left, right) {
          return moment.utc(left.date).diff(moment.utc(right.date))
        })])
      };
    } finally { dataLoading5(true); };
  }
  async function getData6() {
    if (initialapiload === true) {
      try {
        const response = await axios({ method: "post", url: base_url + "/graph/daily-glucose-average", data: mealch6, 'Content-Type': 'application/json', crossDomain: true, headers: { "Authorization": `Bearer ${user}` } })
        if (response.data.response !== "Error while fetching data") {
          setrangeAveDay([response.data.response.sort(function (left, right) {
            return moment.utc(left.date).diff(moment.utc(right.date))
          })])
          setinitapiload(false)
        };
      } finally { dataLoading6(true); };
    }
  }
  async function getData7() {
    try {
      const response = await axios({ method: "post", url: base_url + "/graph/glucose-rangescore-data-extra", data: mealch, 'Content-Type': 'application/json', crossDomain: true, headers: { "Authorization": `Bearer ${user}` } })
      if (response.data.response !== "Error while fetching data") { setExrtarange([response.data.response]) };

    }
    finally { dataLoading7(true); };
  }

  const [fastArr, setfastArr] = useState([]);
  const [rangeArr, setrangArr] = useState([]);
  const [gchartArr, setGchartArr] = useState([]);
  const [filteredGlucose, setFilteredGlucose] = useState([]);
  const [wchartArr, setwchartArr] = useState([]);
  const [wchartArr1, setwchartArr1] = useState([]);
  const [intialLoad3, setinit3] = useState(false);

  const updateState0 = () => {
    if (Array.isArray(gchart?.[0])) {
      // Calculate the 24-hour window for the glucose chart
      // If viewing today, end at current time to avoid blank space for future
      // If viewing a past date, show the full day
      const isViewingToday = moment(DATE).isSame(moment(), 'day');
      const endOfWindow = isViewingToday ? moment() : moment(DATE).endOf('day');
      const startOf24HourWindow = moment(endOfWindow).subtract(24, 'hours').startOf('hour');
      
      const newState = gchart[0].map((obj, i) => {
        setinit3(true)
        // Backend now returns local timestamps (no Z) - parse as local time
        var convertedTime = new Date(moment(obj.timestamp).toISOString());
        // Use glucose value in mg/dL (from backend), clamped to valid range
        var gls = clampGlucose(obj.glucose_avg || obj.glucose);
        // Filter to show data within the 24-hour window (ending at current time if today)
        if (moment(convertedTime).isSameOrBefore(endOfWindow) && moment(convertedTime).isSameOrAfter(startOf24HourWindow)) {
          // IMPORTANT: t2 must be a number (not string) to match the X-axis numeric domain
          return { ...obj, t2: parseInt(moment(convertedTime).format('X'), 10), gv: gls, converted: convertedTime }
        }
        return null;
      }).filter((item) => item !== null)

      const filterMinutes = 14; // specify the minimum minutes difference
      // Function to apply iterative filtering where the filter restarts with each new value
      const applyIterativeFilter = (eventsArray, minutesDiff) => {
        const result = [];
        let lastFilteredTime = null; // Keep track of the last filtered time
        eventsArray.forEach((eventItem, index) => {
          if (index === 0) {
            // Always add the first element
            result.push(eventItem);
            lastFilteredTime = eventItem.timestamp;
          } else {
            const previousTime = new Date(lastFilteredTime);
            const currentTime = new Date(eventItem.timestamp);
            // Calculate the difference in minutes
            const diffInMinutes = (currentTime - previousTime) / (1000 * 60);
            // If the difference is greater than or equal to the specified minutes, include it
            if (diffInMinutes >= minutesDiff) {
              result.push(eventItem);
              lastFilteredTime = eventItem.timestamp; // Update the last filtered time
            }
          }
        })
        return result;
      };

      setFilteredGlucose(applyIterativeFilter(newState.sort((a, b) => a.t2 - b.t2), filterMinutes));
      setBrushRange24h({ startIndex: 0, endIndex: null });
      setinit3(true)
    }
  }

  const [initialfil, setinfilter] = useState('6hours');
  const [intialLoad4, setinit4] = useState(false);
  const updateState = () => {
    if (Array.isArray(range[0])) {
      const newState = range[0].slice(0).reverse().map(obj => {
        setinit4(true)
        if (obj.date) {
          return { ...obj, day: getLocalDayName(obj.date) };
        }
        return obj;
      }).sort(function (left, right) {
        return moment(left.date).diff(moment(right.date))
      });
      setrangArr(newState);
    };
  }

  const [intialLoad5, setinit5] = useState(false);
  const updateState1 = () => {
    if (Array.isArray(fasting[0])) {
      const newState = fasting[0].slice(0).reverse().map(obj => {
        if (obj.date) {
          return { ...obj, day: getLocalDayName(obj.date) };
        }
        return obj;
      }).sort(function (left, right) {
        return moment(left.date).diff(moment(right.date))
      });
      setfastArr(newState);
      setinit5(true)
    };
  }

  const sdg1 = moment(DATE).startOf('isoWeek').format('YYYY-MM-DD');
  const edg1 = DATE;
  const [intialLoad6, setinit6] = useState(false);
  const updateState3 = (s, e) => {
    if (Array.isArray(wchart[0])) {
      const newState = wchart[0].map(obj => {
        setinit6(true);
        if (obj.timestamp) {
          return { ...obj, day: getLocalDayName(obj.date) };
        }
        return obj;
      }).sort((a, b) => moment(a.date).diff(moment(b.date)));

      setwchartArr1(newState);

      // Only slice if we have valid indices
      if (newState.length > 0) {
        const a = newState.findIndex((obj) => moment(obj.date).format('YYYY-MM-DD') === s);
        const b = newState.findIndex((obj) => moment(obj.date).format('YYYY-MM-DD') === e);

        if (a !== -1 && b !== -1) {
          const slicedData = newState.slice(a, b + 1);
          setwchartArr(slicedData);
        } else {
          setwchartArr(newState);
        }
      }
    }
  };

  const [extrarangeF, setextrarangeF] = useState([])
  const [intialLoad7, setinit7] = useState(false);
  const updateState7 = () => {
    if (Array.isArray(Extrarange[0])) {

      const newState = Extrarange[0].slice(0).reverse().map(obj => {
        setinit7(true)
        if (obj.total_above_180 > 0) {
          return { ...obj, cat_180: obj.total_above_180, day: getLocalDayName(obj.date) };
        } else if (obj.total_below_70 > 0) {
          return { ...obj, cat_70: obj.total_below_70, day: getLocalDayName(obj.date) };
        } else {
          return { ...obj, day: getLocalDayName(obj.date) };
        }
      });



      setextrarangeF(newState.sort(function (left, right) {
        return moment.utc(left.date).diff(moment.utc(right.date))
      }));

    };
  }

  const [fortyday, setforty] = useState([]);
  const [intialLoad, setinit] = useState(false);
  const [selectedItem, setSelected] = useState('first');
  const nextPrev = (action) => {
    if (Array.isArray(rangeAve[0])) {
      if (action === 'last') {
        const s = moment(DATE).subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
        const e = moment(DATE).subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
        var a = parseInt(rangeAve[0].findIndex((obj) => (obj.date === s)));
        var b = parseInt(rangeAve[0].findIndex((obj) => (obj.date === e)));
        setforty(rangeAve[0].slice(a, b + 1));
        setinit(true)
      } else if (action === 'first') {
        const s = moment(DATE).startOf('isoWeek').format('YYYY-MM-DD');
        const e = moment(DATE).endOf('isoWeek').format('YYYY-MM-DD');
        var a2 = parseInt(rangeAve[0].findIndex((obj) => (obj.date === s)));
        var b2 = parseInt(rangeAve[0].findIndex((obj) => (obj.date === e)));
        setforty(rangeAve[0].slice(a2, b2 + 1));
        setinit(true)
      }
    }
  }
  const [fortyday1, setforty1] = useState([]);
  const [intialLoad1, setinit1] = useState(false);
  const [selectedItem1, setSelected1] = useState('first');
  const nextPrevGMI = (action) => {
    if (Array.isArray(gmi[0])) {
      if (action === 'last') {
        const s = moment(DATE).subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
        const e = moment(DATE).subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
        var a1 = parseInt(gmi[0].findIndex((obj) => (obj.date === s)));
        var b1 = parseInt(gmi[0].findIndex((obj) => (obj.date === e)));
        setforty1(gmi[0].slice(a1, b1 + 1));
        setinit1(true)
      } else if (action === 'first') {
        const s = moment(DATE).startOf('isoWeek').format('YYYY-MM-DD');
        const e = moment(DATE).endOf('isoWeek').format('YYYY-MM-DD');
        var aa = parseInt(gmi[0].findIndex((obj) => (obj.date === s)));
        var bb = parseInt(gmi[0].findIndex((obj) => (obj.date === e)));
        setforty1(gmi[0].slice(aa, bb + 1));
        setinit1(true)
      }
    }
  }

  const CustomizedDot = () => { };
  const [daysNav, setdayNav] = useState('0');
  const dayscroll = (val) => { if (val === 'yes') { setdayNav('1') } else { setdayNav('0') }; }
  const [daysNav1, setdayNav1] = useState('0');
  const dayscroll1 = (val) => { if (val === 'yes') { setdayNav1('1') } else { setdayNav1('0') }; }
  const defaultDate = moment(startDay6, "YYYY-MM-DD").isoWeekday();
  const [day, setDay] = useState((moment(DATE).isoWeekday()));

  // Fetch day details when day selection changes
  useEffect(() => {
    if (userEmail && day) {
      fetchDayDetails(day);
    }
  }, [day, userEmail]);

  // Fetch meal records for 24-hour chart
  const fetchMeals24h = async () => {
    if (!UID) return;
    const isViewingToday = moment(DATE).isSame(moment(), 'day');
    const endOfWindow = isViewingToday ? moment() : moment(DATE).endOf('day');
    const startOf24h = moment(endOfWindow).subtract(24, 'hours').startOf('hour');
    const daysToFetch = [...new Set([startOf24h.format('YYYY-MM-DD'), endOfWindow.format('YYYY-MM-DD')])];
    try {
      const allMeals = [];
      for (const dateStr of daysToFetch) {
        const res = await axios.post(
          base_url + '/admin/meal/get-meal-record',
          { uuid: UID, date: dateStr },
          { headers: { Authorization: `Bearer ${user}` } }
        );
        if (res.data?.response && Array.isArray(res.data.response)) {
          allMeals.push(...res.data.response);
        }
      }
      const mealsInWindow = allMeals
        .filter(m => {
          const ts = m.timestamp || m.created_at || m.time;
          if (!ts) return false;
          const t = typeof ts === 'number' ? moment.unix(ts > 1e10 ? ts / 1000 : ts) : moment(ts);
          return t.isSameOrAfter(startOf24h) && t.isSameOrBefore(endOfWindow);
        })
        .map(m => {
          const ts = m.timestamp || m.created_at || m.time;
          const unix = typeof ts === 'number' ? (ts > 1e10 ? Math.floor(ts / 1000) : ts) : moment(ts).unix();
          return {
            unix,
            meal_type: m.meal_type || 'Meal',
            item_name: m.item_name,
            kcal: m.kcal,
            nutrients: m.nutrients,
            nos: m.nos,
            measurement_unit: m.measurement_unit
          };
        });
      setMealRecords24h(mealsInWindow);
    } catch (err) {
      console.error('Error fetching meals for chart:', err);
      setMealRecords24h([]);
    }
  };

  // Fetch exercise records for 24-hour chart
  const fetchExercise24h = async () => {
    if (!UID) return;
    const isViewingToday = moment(DATE).isSame(moment(), 'day');
    const endOfWindow = isViewingToday ? moment() : moment(DATE).endOf('day');
    const startOf24h = moment(endOfWindow).subtract(24, 'hours').startOf('hour');
    const todayStr = moment(DATE).format('YYYY-MM-DD');
    const yesterdayStr = moment(DATE).subtract(1, 'days').format('YYYY-MM-DD');
    try {
      const res = await axios.post(
        base_url + '/admin/exercise/get-exercise',
        { uuid: UID, today: todayStr, yesterday: yesterdayStr },
        { headers: { Authorization: `Bearer ${user}` } }
      );
      const data = res.data?.response;
      const rawItems = (Array.isArray(data?.todays_data) ? data.todays_data : []).map(e => ({ ...e, _date: todayStr }));
      const yesterItems = (Array.isArray(data?.yesterdays_data) ? data.yesterdays_data : []).map(e => ({ ...e, _date: yesterdayStr }));
      const allItems = [...rawItems, ...yesterItems];
      const exercisesInWindow = allItems
        .filter((e) => {
          let unix;
          if (e.exercise_type === 'Steps') {
            unix = moment(e._date).set({ hour: 12, minute: 0, second: 0 }).unix();
          } else {
            const ts = e.timestamp;
            if (!ts) return false;
            unix = typeof ts === 'number' ? (ts > 1e10 ? Math.floor(ts / 1000) : ts) : moment(ts).unix();
          }
          const t = moment.unix(unix);
          return t.isSameOrAfter(startOf24h) && t.isSameOrBefore(endOfWindow);
        })
        .map((e) => {
          let unix;
          if (e.exercise_type === 'Steps') {
            unix = moment(e._date).set({ hour: 12, minute: 0, second: 0 }).unix();
          } else {
            const ts = e.timestamp;
            unix = typeof ts === 'number' ? (ts > 1e10 ? Math.floor(ts / 1000) : ts) : moment(ts).unix();
          }
          return {
            unix,
            exercise_type: e.exercise_type || 'Exercise',
            duration: e.duration,
            calories_burn: e.calories_burn
          };
        });
      setExerciseRecords24h(exercisesInWindow);
    } catch (err) {
      console.error('Error fetching exercise for chart:', err);
      setExerciseRecords24h([]);
    }
  };

  // Fetch medication records for 24-hour chart
  const fetchMedications24h = async () => {
    if (!UID) return;
    const isViewingToday = moment(DATE).isSame(moment(), 'day');
    const endOfWindow = isViewingToday ? moment() : moment(DATE).endOf('day');
    const startOf24h = moment(endOfWindow).subtract(24, 'hours').startOf('hour');
    const daysToFetch = [...new Set([startOf24h.format('YYYY-MM-DD'), endOfWindow.format('YYYY-MM-DD')])];
    try {
      const allMeds = [];
      for (const dateStr of daysToFetch) {
        const res = await axios.post(
          base_url + '/medication/mydata-get-medication',
          { uuid: UID, date: dateStr },
          { headers: { Authorization: `Bearer ${user}` } }
        );
        if (res.data?.response && Array.isArray(res.data.response)) {
          allMeds.push(...res.data.response);
        }
      }
      const medsInWindow = allMeds
        .filter(m => {
          const ts = m.timestamp || m.created_at || m.log_time || m.date;
          if (!ts) return false;
          const t = typeof ts === 'number' ? moment.unix(ts > 1e10 ? ts / 1000 : ts) : moment(ts);
          return t.isSameOrAfter(startOf24h) && t.isSameOrBefore(endOfWindow);
        })
        .map(m => {
          const ts = m.timestamp || m.created_at || m.log_time || m.date;
          const unix = typeof ts === 'number' ? (ts > 1e10 ? Math.floor(ts / 1000) : ts) : moment(ts).unix();
          const nameLC = (m.name || m.medication_name || '').toLowerCase();
          const typeLC = (m.type || m.medication_type || '').toLowerCase();
          const isInsulin = nameLC.includes('insulin') || typeLC.includes('insulin');
          return {
            unix,
            name: m.name || m.medication_name || 'Medication',
            type: m.type || m.medication_type || '',
            value: m.value,
            isInsulin,
          };
        });
      setMedicationRecords24h(medsInWindow);
    } catch (err) {
      console.error('Error fetching medications for chart:', err);
      setMedicationRecords24h([]);
    }
  };

  useEffect(() => {
    // Update 24-hour chart when data loads
    if (loaded3 === true && intialLoad3 === false) { updateState0(); }

    // Check if we need to reset data (UID changed)
    if (dataForUID && dataForUID !== UID) {
      setGlucoseChartData([]);
      setOverlayChartData([]);
      setOverlayDayKeys([]);
      setSelectedOverlayDays(new Set());
      setMealRecords24h([]);
      setExerciseRecords24h([]);
      setMedicationRecords24h([]);
      setInfluxRangeScoreData([]);
      setLastFetchedEmail(null);
      setFilteredGlucose([]);
      setDataForUID(null);
    }
    
    // Fetch data - InfluxDB endpoint provides all the data we need
    const fetchAllData = async () => {
      const promises = [];
      
      // 24-hour glucose chart (uses InfluxDB with 5min aggregation)
      if (loaded3 === false && userEmail) promises.push(getData3());

      // Meal, exercise, and medication records for 24-hour chart
      if (initialfil === '6hours' && UID) {
        promises.push(fetchMeals24h());
        promises.push(fetchExercise24h());
        promises.push(fetchMedications24h());
      }
      
      // Main InfluxDB data fetch - powers Time in Range, Fasting, GMI, Daily Avg, Extra Range charts
      if (!loadingInfluxRange && userEmail && (userEmail !== lastFetchedEmail || dataForUID !== UID || DATE !== lastFetchedDate || deviceBootAt !== lastFetchedBootAt)) {
        setLastFetchedEmail(userEmail);
        setDataForUID(UID);
        setLastFetchedDate(DATE);
        setLastFetchedBootAt(deviceBootAt);
        promises.push(fetchInfluxTimeInRange());
      }
      
      // Execute API calls in parallel
      if (promises.length > 0) {
        await Promise.all(promises);
      }
    };
    
    fetchAllData();

  }, [gchart, UID, dataForUID, userEmail, lastFetchedEmail, lastFetchedDate, loadingInfluxRange, DATE, initialfil, targetLower, targetUpper, deviceBootAt]);



  const formatXAxis = (tickFormat) => {
    return moment(tickFormat, 'X').format('ha');
  };

  const CustomTooltip = ({ active, payload, label }) => {
    return (
      <p className="label">{moment(`${payload?.[0]?.payload?.converted}`).format('h:mm a')} <br />
        {`${payload?.[0]?.value}`}
      </p>
    )
  }

  let hr = moment(past_ct).format('YYYY-MM-DD HH');

  for (let i = 0; 25 > i; i = i + 3) {
    // Store as numbers to match the numeric t2 values in the data
    timeArray.push(parseInt(moment(hr, 'YYYY-MM-DD HH').add(i, 'hours').format('X'), 10))
  }

  const fastingGlucoseData = graphData?.fasting_glucose || [];
  const gmiData = graphData?.gmi_data || [];
  const rangeScoreData = graphData?.range_score || [];
  const glucoseData = graphData?.glucose_data || [];
  const dailyAverageData = graphData?.daily_average || [];
  const extraRangeData = graphData?.extra_range || [];

  // Add function to handle time period changes
  const handleTimePeriodChange = async (val) => {
    setinfilter(val);
    let startDate, endDate;

    // Set loading state for weekly views
    if (val === 'week' || val === 'last7days') {
      setLoadingWeeklyData(true);
      setGlucoseChartData([]); // Clear previous data
      if (val === 'last7days') {
        setOverlayChartData([]);
        setOverlayDayKeys([]);
        setSelectedOverlayDays(new Set());
      }
    }

    // Use device boot/expire dates if available
    const deviceBootAt = localStorage.getItem("deviceBootAt");
    const deviceExpireAt = localStorage.getItem("deviceExpireAt");

    switch (val) {
      case 'last7days':
        if (deviceBootAt && deviceExpireAt) {
          startDate = moment.unix(parseInt(deviceBootAt)).format('YYYY-MM-DD');
          endDate = moment.unix(parseInt(deviceExpireAt)).format('YYYY-MM-DD');
        } else {
          startDate = moment(DATE).subtract(14, 'days').format('YYYY-MM-DD');
          endDate = moment(DATE).format('YYYY-MM-DD');
        }
        break;
      case 'week':
        if (deviceBootAt && deviceExpireAt) {
          startDate = moment.unix(parseInt(deviceBootAt)).format('YYYY-MM-DD');
          endDate = moment.unix(parseInt(deviceExpireAt)).format('YYYY-MM-DD');
        } else {
          startDate = moment(DATE).subtract(14, 'days').format('YYYY-MM-DD');
          endDate = moment(DATE).format('YYYY-MM-DD');
        }
        break;
      case '6hours':
      default:
        startDate = moment(DATE).subtract(24, 'hours').format('YYYY-MM-DD');
        endDate = moment(DATE).format('YYYY-MM-DD');
        break;
    }

    // Get user's timezone
    const userTimezone = getUserTimezone();

    try {
      const isOverlayView = val === 'last7days';
      const isWeekView = val === 'week';
          // Overlay: 15min for 15 days. Week: daily. 24-hour: 15min
      const endpoint = (isOverlayView || val === '6hours')
        ? base_url + '/admin/influxdb/glucose-data?aggregate=15min'
        : base_url + '/admin/influxdb/glucose-data?aggregate=daily';

      // Backend now handles timezone conversion - send LOCAL dates
      const response = await axios.post(
        endpoint,
        {
          uuid: UID,
          email: userEmail,
          start_date: startDate,  // Local date
          end_date: endDate,      // Local date
          timezone: userTimezone, // NEW: User's timezone
          is_admin: 'True'
        },
        { headers: { "Authorization": `Bearer ${user}` } }
      );

      if (response.data.response !== "Error while fetching data") {
        if (isOverlayView) {
          // Overlay: group by date across the device period, normalize to hour 0-24
          const cgmData = response.data.response?.cgm_data || [];
          const localStart = moment(startDate).startOf('day');
          const localEnd = moment(endDate).startOf('day');
          const totalDays = localEnd.diff(localStart, 'days') + 1;
          const dayKeys = [];
          const readingsByDay = {};

          for (let i = 0; i < totalDays; i++) {
            const d = moment(localStart).add(i, 'days');
            const label = d.format('ddd MMM D');
            dayKeys.push(label);
            readingsByDay[label] = [];
          }

          cgmData.forEach(reading => {
            const glucose = clampGlucose(reading.glucose_avg || reading.glucose);
            const timestamp = reading.timestamp || reading.time || reading._time;
            if (!glucose || !timestamp) return;

            const t = moment(timestamp);
            const dateStr = t.format('YYYY-MM-DD');
            const label = t.format('ddd MMM D');
            if (!readingsByDay[label]) return;

            const fractionalHour = t.hour() + t.minute() / 60 + t.second() / 3600;
            readingsByDay[label].push({ hour: fractionalHour, glucose });
          });

          // Build merged rows: one per 15-min slot (0, 0.25, 0.5, ... 23.75)
          const hourSlots = [];
          for (let h = 0; h < 24; h++) {
            for (let q = 0; q < 4; q++) {
              hourSlots.push(h + q * 0.25);
            }
          }

          const overlayData = hourSlots.map(hour => {
            const row = { hour };
            dayKeys.forEach(label => {
              const readings = readingsByDay[label];
              const minH = hour - 0.125;
              const maxH = hour + 0.125;
              const nearby = readings.filter(r => r.hour >= minH && r.hour <= maxH);
              if (nearby.length > 0) {
                const avg = nearby.reduce((s, r) => s + r.glucose, 0) / nearby.length;
                row[label] = Math.round(avg * 10) / 10;
              } else {
                row[label] = null;
              }
            });
            return row;
          });

          setOverlayChartData(overlayData);
          setOverlayDayKeys(dayKeys);
          setSelectedOverlayDays(new Set(dayKeys));
        } else if (isWeekView) {
          // Week: pre-aggregated daily data from backend
          const cgmData = response.data.response?.cgm_data || [];
          const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
          const selectedDate = moment(DATE);
          const weekStart = moment(selectedDate).startOf('isoWeek');

          const chartData = daysOfWeek.map((day, index) => {
            const targetDate = moment(weekStart).add(index, 'days').format('YYYY-MM-DD');
            const dayData = cgmData.find(item => item.date === targetDate);
            return {
              day,
              glucose: dayData?.glucose_avg ?? 0
            };
          });

          setGlucoseChartData(chartData);
          setwChart([chartData]);
        } else {
          // 24-hour view: use raw minute-by-minute data
          setGChart([response.data.response.cgm_data]);
        }

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingWeeklyData(false);
    }
  };

  const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const rangeScoreByDay = {};
  if (Array.isArray(rangeArr)) {
    rangeArr.forEach(item => {
      rangeScoreByDay[item.day] = typeof item.range_score === 'number' ? item.range_score : null;
    });
  }
  const rangeScoreChartData = daysOfWeek.map(day => ({
    day,
    range_score: rangeScoreByDay[day] !== undefined ? rangeScoreByDay[day] : null
  }));

  const fastingByDay = {};
  if (Array.isArray(fastArr)) {
    fastArr.forEach(item => {
      fastingByDay[item.day] = typeof item.blood_glucose_mg_per_dL === 'number' ? item.blood_glucose_mg_per_dL : null;
    });
  }
  const fastingChartData = daysOfWeek.map(day => ({
    day,
    blood_glucose_mg_per_dL: fastingByDay[day] !== undefined ? fastingByDay[day] : null
  }));

  const extraRangeByDay = {};
  if (Array.isArray(extrarangeF)) {
    extrarangeF.forEach(item => {
      extraRangeByDay[item.day] = {
        cat_70: typeof item.cat_70 === 'number' ? item.cat_70 : null,
        cat_180: typeof item.cat_180 === 'number' ? item.cat_180 : null
      };
    });
  }
  const extraRangeChartData = daysOfWeek.map(day => ({
    day,
    cat_70: extraRangeByDay[day]?.cat_70 ?? null,
    cat_180: extraRangeByDay[day]?.cat_180 ?? null
  }));

  const gmiByDay = {};
  if (Array.isArray(fortyday1)) {
    fortyday1.forEach(item => {
      const day = getLocalDayName(item.date);
      gmiByDay[day] = typeof item.gmi === 'number' ? item.gmi : null;
    });
  }
  const gmiChartData = daysOfWeek.map(day => ({
    day,
    gmi: gmiByDay[day] !== undefined ? gmiByDay[day] : null
  }));

  const toggleOverlayDay = (label) => {
    setSelectedOverlayDays(prev => {
      const next = new Set(prev);
      if (next.has(label)) next.delete(label);
      else next.add(label);
      return next;
    });
  };

  return (

    <div className='col col-100'>
      <h2>Glucose Monitoring</h2>
      <div className='col-group two-col'>


        <div className='col-wrapper exercise full-width-blk' id='gcs'>
          <div className='filter-wrapper'>

            <div className='left-div'><div className='total-cal dark-text'>Glucose Chart  <span>mg/dL</span></div>

            </div>
            <div className='right-div'>
              <Select dropdownPosition="bottom" placeholder='Last 24 hours' defaultValue={'6hours'} data={[{ value: '6hours', label: 'Last 24 hours' }, { value: 'week', label: 'Week' }, { value: 'last7days', label: 'Last 15 Days' }]} onChange={(val) => handleTimePeriodChange(val)} ></Select>
            </div>
          </div>




          {initialfil === '6hours' && Array.isArray(gchart) ?
            <>
              {loaded3 === false ? <Loader /> : (



                <>
                  {(() => {
                    const data = filteredGlucose;
                    const len = data?.length || 0;
                    const { startIndex, endIndex } = brushRange24h;
                    let rangeStart = 0, rangeEnd = len - 1;
                    if (len > 0 && endIndex != null && startIndex != null && endIndex >= startIndex) {
                      rangeStart = Math.max(0, Math.min(startIndex, len - 1));
                      rangeEnd = Math.max(0, Math.min(endIndex, len - 1));
                    }
                    const vals = (len ? data.slice(rangeStart, rangeEnd + 1).map(d => d.gv).filter(v => v != null) : []);
                    const lower = targetLower ?? 70;
                    const upper = targetUpper ?? 180;
                    const dataMin = vals.length ? Math.min(...vals) : lower;
                    const dataMax = vals.length ? Math.max(...vals) : upper;
                    const yMin = Math.max(0, Math.min(lower - 20, dataMin - 10));
                    const yMax = Math.min(450, Math.max(upper + 20, dataMax + 10));
                    const yFloor = Math.floor(yMin);
                    const yCeil = Math.ceil(yMax);
                    const yDomain = [yFloor, yCeil];
                    return (
                  <div style={{ position: 'relative' }}>
                      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 10px 15px', marginBottom: 15 }}>
                        <span style={{ fontSize: 11, color: '#666', fontWeight: 500 }}>
                          Target Range: {targetLower}–{targetUpper} mg/dL
                        </span>
                      </div>
                      <div style={{ width: '100%', height: '360px', position: 'relative' }}>
                        <ResponsiveContainer width={"100%"} height={330} >

                          <LineChart data={filteredGlucose} margin={{ top: 15, right: 10, left: -15, bottom: 5, }} >
                            <defs>
                              {(() => {
                                const allGV = (filteredGlucose || []).map(d => d.gv).filter(v => v != null);
                                if (!allGV.length) {
                                  return (
                                    <linearGradient id="glucoseLineColor24h" x1="0" y1="0" x2="0" y2="1">
                                      <stop offset="0%" stopColor="#2E7D32" /><stop offset="100%" stopColor="#2E7D32" />
                                    </linearGradient>
                                  );
                                }
                                const pathTop = Math.max(...allGV);
                                const pathBottom = Math.min(...allGV);
                                const pathSpan = pathTop - pathBottom;
                                if (pathSpan < 0.01) {
                                  const c = pathTop > upper ? '#FF8C42' : pathTop < lower ? '#EC0909' : '#2E7D32';
                                  return (
                                    <linearGradient id="glucoseLineColor24h" x1="0" y1="0" x2="0" y2="1">
                                      <stop offset="0%" stopColor={c} /><stop offset="100%" stopColor={c} />
                                    </linearGradient>
                                  );
                                }
                                const stops = [];
                                if (pathTop > upper) {
                                  const pct = ((pathTop - upper) / pathSpan) * 100;
                                  stops.push(<stop key="s0" offset="0%" stopColor="#FF8C42" />);
                                  stops.push(<stop key="s1" offset={`${pct}%`} stopColor="#FF8C42" />);
                                  stops.push(<stop key="s2" offset={`${pct}%`} stopColor="#2E7D32" />);
                                } else {
                                  stops.push(<stop key="s0" offset="0%" stopColor="#2E7D32" />);
                                }
                                if (pathBottom < lower) {
                                  const pct = ((pathTop - lower) / pathSpan) * 100;
                                  stops.push(<stop key="s3" offset={`${pct}%`} stopColor="#2E7D32" />);
                                  stops.push(<stop key="s4" offset={`${pct}%`} stopColor="#EC0909" />);
                                  stops.push(<stop key="s5" offset="100%" stopColor="#EC0909" />);
                                } else {
                                  stops.push(<stop key="s5" offset="100%" stopColor="#2E7D32" />);
                                }
                                return (
                                  <linearGradient id="glucoseLineColor24h" x1="0" y1="0" x2="0" y2="1">
                                    {stops}
                                  </linearGradient>
                                );
                              })()}
                            </defs>

                            <CartesianGrid vertical={false} strokeDasharray="10 10" />

                            <XAxis
                              axisLine={true}
                              type="number"
                              domain={(() => {
                                const len = filteredGlucose?.length || 0;
                                if (len === 0 || !timeArray?.length) return [timeArray?.[0], timeArray?.[timeArray?.length - 1]];
                                const { startIndex, endIndex } = brushRange24h;
                                if (endIndex != null && startIndex != null && endIndex >= startIndex) {
                                  const start = Math.max(0, Math.min(startIndex, len - 1));
                                  const end = Math.max(0, Math.min(endIndex, len - 1));
                                  return [filteredGlucose[start].t2, filteredGlucose[end].t2];
                                }
                                return [timeArray[0], timeArray[timeArray.length - 1]];
                              })()}
                              tickLine={true}
                              padding={{ left: 20, right: 20 }}
                              dataKey='t2'
                              interval={0}
                              tickFormatter={(tick) => formatXAxis(tick)}
                            />

                            <YAxis 
                              type="number" 
                              axisLine={false} 
                              tickLine={false} 
                              tick={{ fill: '#111' }} 
                              domain={[yFloor, yCeil]}
                            />

                            <Tooltip label='Time' content={<CustomTooltip />} />
                            <ReferenceArea y2={targetLower} fill="#FF8C42" fillOpacity={0.12} />
                            <ReferenceArea y1={targetLower} y2={targetUpper} fill="#4CAF50" fillOpacity={0.12} />
                            <Line connectNulls allowDecimals={false} dot={false} isAnimationActive={false} activeDot={true} type="monotone" dataKey="gv" strokeWidth={2} stroke="url(#glucoseLineColor24h)" name="Glucose" />

                          </LineChart></ResponsiveContainer>
                      </div>
                      {timeArray?.length >= 2 && (mealRecords24h.length > 0 || exerciseRecords24h.length > 0 || medicationRecords24h.length > 0) && (() => {
                          const len = filteredGlucose?.length || 0;
                          const { startIndex, endIndex } = brushRange24h;
                          const domainMin = (endIndex != null && startIndex != null && len > 0)
                            ? filteredGlucose[Math.min(startIndex, len - 1)].t2
                            : timeArray[0];
                          const domainMax = (endIndex != null && startIndex != null && len > 0)
                            ? filteredGlucose[Math.min(endIndex, len - 1)].t2
                            : timeArray[timeArray.length - 1];
                          const span = domainMax - domainMin || 1;
                          return (
                            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 35, pointerEvents: 'none', display: 'flex', alignItems: 'flex-end' }}>
                              {mealRecords24h.filter(m => m.unix >= domainMin && m.unix <= domainMax).map((meal, idx) => {
                                const pct = (meal.unix - domainMin) / span;
                                return (
                                  <MealIcon
                                    key={`meal-${idx}-${meal.unix}`}
                                    size={18}
                                    fill="#E65100"
                                    style={{
                                      position: 'absolute',
                                      left: `${pct * 100}%`,
                                      transform: 'translateX(-50%)',
                                      bottom: 0,
                                      pointerEvents: 'auto',
                                      cursor: 'pointer'
                                    }}
                                  />
                                );
                              })}
                              {exerciseRecords24h.filter(ex => ex.unix >= domainMin && ex.unix <= domainMax).map((ex, idx) => {
                                const pct = (ex.unix - domainMin) / span;
                                return (
                                  <ExerciseIcon
                                    key={`exercise-${idx}-${ex.unix}`}
                                    size={18}
                                    fill="#3245BD"
                                    style={{
                                      position: 'absolute',
                                      left: `${pct * 100}%`,
                                      transform: 'translateX(-50%)',
                                      bottom: 0,
                                      pointerEvents: 'auto',
                                      cursor: 'pointer'
                                    }}
                                  />
                                );
                              })}
                              {medicationRecords24h.filter(med => med.unix >= domainMin && med.unix <= domainMax).map((med, idx) => {
                                const pct = (med.unix - domainMin) / span;
                                const Icon = med.isInsulin ? SyringeIcon : PillIcon;
                                return (
                                  <Icon
                                    key={`med-${idx}-${med.unix}`}
                                    size={18}
                                    fill={med.isInsulin ? '#9C27B0' : '#F0206B'}
                                    title={`${med.name}${med.value ? ` – ${med.value}` : ''}`}
                                    style={{
                                      position: 'absolute',
                                      left: `${pct * 100}%`,
                                      transform: 'translateX(-50%)',
                                      bottom: 0,
                                      pointerEvents: 'auto',
                                      cursor: 'pointer'
                                    }}
                                  />
                                );
                              })}
                            </div>
                          );
                        })()}
                  </div>
                    );
                  })()}
                </>
              )}
            </>
            : ''}

          {initialfil === 'week' ?
            <>
              {loadingWeeklyData ? <Loader /> : (
                <ResponsiveContainer width={'100%'} height={300}>
                  <LineChart
                    data={glucoseChartData}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                  >
                    <CartesianGrid vertical={false} strokeDasharray="10 10" />
                    <XAxis
                      axisLine={false}
                      tickLine={false}
                      dataKey="day"
                      padding={{ left: 20, right: 20 }}
                      tick={{ fill: '#111' }}
                      tickCount={7}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      domain={['auto', 'auto']}
                      minTickGap={5}
                      tickCount={7}
                      tick={{ fill: '#111' }}
                    />
                    <Tooltip cursor={{ fill: 'transparent' }} />
                    <Line
                      connectNulls
                      allowDecimals={false}
                      dot={{ r: 5, fill: '#fff', stroke: '#0051A6', strokeWidth: 2 }}
                      isAnimationActive={false}
                      activeDot={{ r: 7 }}
                      type="monotone"
                      dataKey="glucose"
                      stroke="#0051A6"
                      strokeWidth={2}
                    />
                  </LineChart>
                </ResponsiveContainer>
              )}
              <div className='chartlabel'>15 Days</div>
            </>
            : ''}

          {initialfil === 'last7days' ?
            <>
              {loadingWeeklyData ? <Loader /> : (
                <>
                  <div style={{ marginBottom: 4, fontSize: 11, color: '#666', textAlign: 'center' }}>Click a day to show or hide</div>
                  <div className="overlay-legend" style={{ display: 'flex', flexWrap: 'wrap', gap: '12px 20px', marginBottom: 8, justifyContent: 'center' }}>
                    {overlayDayKeys.map((label, i) => {
                      const isSelected = selectedOverlayDays.has(label);
                      return (
                        <div
                          key={label}
                          role="button"
                          tabIndex={0}
                          onClick={() => toggleOverlayDay(label)}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleOverlayDay(label); } }}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            cursor: 'pointer',
                            opacity: isSelected ? 1 : 0.4,
                            textDecoration: isSelected ? 'none' : 'line-through',
                            padding: '2px 4px',
                            borderRadius: 4
                          }}
                        >
                          <span style={{ width: 12, height: 3, backgroundColor: OVERLAY_COLORS[i], borderRadius: 1 }} />
                          <span style={{ fontSize: 12, color: '#333' }}>{label}</span>
                        </div>
                      );
                    })}
                  </div>
                  <ResponsiveContainer width="100%" height={350}>
                    <LineChart
                      data={overlayChartData}
                      margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                    >
                      <CartesianGrid vertical={false} strokeDasharray="10 10" />
                      <XAxis
                        type="number"
                        dataKey="hour"
                        domain={[0, 24]}
                        ticks={[0, 3, 6, 9, 12, 15, 18, 21, 24]}
                        tickFormatter={formatOverlayHour}
                        axisLine={false}
                        tickLine={false}
                        padding={{ left: 20, right: 20 }}
                        tick={{ fill: '#111' }}
                      />
                      <YAxis
                        type="number"
                        domain={(() => {
                          const keys = overlayDayKeys.filter(k => selectedOverlayDays.has(k));
                          const vals = overlayChartData.flatMap(row =>
                            keys.map(k => row[k]).filter(v => v != null)
                          );
                          const dataMin = vals.length ? Math.min(...vals) : targetLower;
                          const dataMax = vals.length ? Math.max(...vals) : targetUpper;
                          const yMin = Math.max(0, Math.min(targetLower - 2, dataMin - 1));
                          const yMax = Math.min(30, Math.max(targetUpper + 2, dataMax + 1));
                          return [Math.floor(yMin * 2) / 2, Math.ceil(yMax * 2) / 2];
                        })()}
                        axisLine={false}
                        tickLine={false}
                        tick={{ fill: '#111' }}
                      />
                      <Tooltip
                        content={({ active, payload, label }) => {
                          if (!active || !payload?.length) return null;
                          const hour = payload[0]?.payload?.hour;
                          return (
                            <div style={{ background: '#fff', border: '1px solid #ccc', borderRadius: 4, padding: '8px 12px', fontSize: 12, boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
                              <div style={{ marginBottom: 6, fontWeight: 600 }}>{formatOverlayHour(hour)}</div>
                              {overlayDayKeys.filter(k => selectedOverlayDays.has(k)).map((dayLabel, idx) => {
                                const i = overlayDayKeys.indexOf(dayLabel);
                                const val = payload[0]?.payload?.[dayLabel];
                                return (
                                  <div key={dayLabel} style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                    <span style={{ width: 8, height: 2, backgroundColor: OVERLAY_COLORS[i] }} />
                                    <span>{dayLabel}:</span>
                                    <span>{val != null ? `${val} mg/dL` : '—'}</span>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        }}
                      />
                      <ReferenceArea y2={targetLower} fill="#FF8C42" fillOpacity={0.12} />
                      <ReferenceArea y1={targetLower} y2={targetUpper} fill="#4CAF50" fillOpacity={0.12} />
                      {overlayDayKeys.filter(label => selectedOverlayDays.has(label)).map((label) => {
                        const i = overlayDayKeys.indexOf(label);
                        return (
                          <Line
                            key={label}
                            type="monotone"
                            dataKey={label}
                            stroke={OVERLAY_COLORS[i]}
                            strokeWidth={i === overlayDayKeys.length - 1 ? 3 : 1.5}
                            dot={false}
                            connectNulls
                            isAnimationActive={false}
                            name={label}
                          />
                        );
                      })}
                    </LineChart>
                  </ResponsiveContainer>
                </>
              )}
              <div className='chartlabel'>15 days overlaid (0–24h)</div>
            </>
            : ''}
        </div>

        <div className='col-wrapper exercise' id="gcs1">
          <div className='filter-wrapper'>
            <div className='left-div'><div className='total-cal dark-text'>Time in Range ({targetLower} - {targetUpper} mg/dL)
            <br />
            %
          </div></div>
            <div className='right-div'>
              <Select readOnly dropdownPosition="bottom" placeholder={avgTimeInRange != null ? `Avg: ${avgTimeInRange}%` : 'No data'} defaultValue={'avg'} data={[{ value: 'avg', label: avgTimeInRange != null ? `Avg: ${avgTimeInRange}%` : 'No data' }]} />
            </div>
          </div>
          {/* Use InfluxDB-calculated range score if available, otherwise fall back to old API */}
          {loadingInfluxRange ? <Loader /> : influxRangeScoreData.length > 0 ? (
            <>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={influxRangeScoreData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: '#111' }}
                    dataKey="day"
                    padding={{ left: 20, right: 20 }}
                    tickCount={15}
                    minTickGap={10}
                  />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={[0, 100]} minTickGap={12} tickCount={6} ticks={['0', '20', '40', '60', '80', '100']} />
                  <Tooltip formatter={(value) => [`${value}%`, 'Time in Range']} />
                  <Line connectNulls allowDecimals={false} dot={true} isAnimationActive={false} activeDot={true} type="monotone" dataKey="range_score" stroke="#0051A6" name='Range' />
                </LineChart>
              </ResponsiveContainer>
              <div className='chartlabel'>15 Days</div>
            </>
          ) : loaded2 === false ? <Loader /> : (
            <>
              {Array.isArray(rangeScoreChartData) ? (
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={rangeScoreChartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid vertical={false} strokeDasharray="10 10" />
                    <XAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{ fill: '#111' }}
                      dataKey="day"
                      padding={{ left: 20, right: 20 }}
                      tickCount={7}
                      minTickGap={10}
                    />
                    <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={[40, 100]} minTickGap={12} tickCount={6} ticks={['40', '52', '64', '76', '88', '100']} />
                    <Tooltip />
                    <Line connectNulls allowDecimals={false} dot={true} isAnimationActive={false} activeDot={true} type="monotone" dataKey="range_score" stroke="#0051A6" name='Range' />
                  </LineChart>
                </ResponsiveContainer>
              ) : ''} 
              <div className='chartlabel'>15 Days</div>
            </>
          )}
        </div>


        <div className='col-wrapper exercise' id='gcs2'>

          <div className='filter-wrapper'>
            <div className='left-div'><div className='total-cal dark-text'>Time In Range (others)
            <br />
            %
          </div></div>
            <div className='right-div'>
              <Select readOnly dropdownPosition="bottom" placeholder={avgExtraRange.below != null ? `Below ${avgExtraRange.below}% | Above ${avgExtraRange.above}%` : 'No data'} defaultValue={'avg'} data={[{ value: 'avg', label: avgExtraRange.below != null ? `Below ${avgExtraRange.below}% | Above ${avgExtraRange.above}%` : 'No data' }]} />
            </div>
          </div>

          {/* Use InfluxDB data if available, otherwise fall back to old API */}
          {loadingInfluxRange ? <Loader /> : influxExtraRangeData.length > 0 ? (
            <>
              <div className='text'>&#60; {targetLower} mg/dL (Low)</div>
              <ResponsiveContainer width="100%" height={150}>
                <LineChart data={influxExtraRangeData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} dataKey="day" padding={{ left: 20, right: 20 }} style={{ fontSize: '0.85rem' }} tickCount='7' minTickGap={10}   />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={['auto', 'auto']} minTickGap={12} tickCount='6' />
                  <Tooltip />
                  <Line connectNulls allowDecimals={false} dot={true} isAnimationActive={false} activeDot={true} type="monotone" dataKey="cat_70" stroke="#E53935" name='Below Range %' />
                </LineChart>
              </ResponsiveContainer>
              <div className='text'>&#62; {targetUpper} mg/dL (High)</div>
              <ResponsiveContainer width="100%" height={150}>
                <LineChart data={influxExtraRangeData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} dataKey="day" padding={{ left: 20, right: 20 }} style={{ fontSize: '0.85rem' }} tickCount='7' minTickGap={10}   />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} minTickGap={12} tickCount='6' domain={['auto', 'auto']} />
                  <Tooltip />
                  <Line connectNulls allowDecimals={false} dot={true} isAnimationActive={false} activeDot={true} type="monotone" dataKey="cat_180" stroke="#FF9800" name='Above Range %' />
                </LineChart>
              </ResponsiveContainer>
            </>
          ) : loaded7 === false ? <Loader /> : (
            <>
              <div className='text'>&#60; {targetLower}</div>
              {Array.isArray(extraRangeChartData) ? (
                <ResponsiveContainer width="100%" height={150}><LineChart data={extraRangeChartData} margin={{ top: 5, right: 30, left: 20, bottom: 5, }} >
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} dataKey="day" padding={{ left: 20, right: 20 }} style={{ fontSize: '0.85rem' }} tickCount='7' minTickGap={10}   />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={['auto', 'auto']} minTickGap={12} tickCount='6' />
                  <Tooltip />
                  <Line connectNulls allowDecimals={false} dot={true} isAnimationActive={false} activeDot={true} type="monotone" dataKey="cat_70" stroke="#0051A6" name='Range' />
                </LineChart></ResponsiveContainer>
              ) : ''}
              <div className='text'>&#62; {targetUpper}</div>
              {Array.isArray(extraRangeChartData) ? (
                <ResponsiveContainer width="100%" height={150}><LineChart data={extraRangeChartData} margin={{ top: 5, right: 30, left: 20, bottom: 5, }} >
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} dataKey="day" padding={{ left: 20, right: 20 }} style={{ fontSize: '0.85rem' }} tickCount='7' minTickGap={10}   />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} minTickGap={12} tickCount='6' domain={['auto', 'auto']} />
                  <Tooltip />
                  <Line connectNulls allowDecimals={false} dot={true} isAnimationActive={false} activeDot={true} type="monotone" dataKey="cat_180" stroke="#0051A6" name='Range' />
                </LineChart></ResponsiveContainer>
              ) : ''}
            </>
          )}
          <div className='chartlabel'>15 Days</div>
        </div>




        <div className='col-wrapper exercise' id='gcs3'>


          <div className='filter-wrapper'>

            <div className='left-div'><div className='total-cal dark-text'>Fasting Glucose
              <span>mg/dL</span>
            </div>

            </div>
            <div className='right-div'>
              <Select readOnly dropdownPosition="bottom" placeholder={avgFasting ? `Avg: ${avgFasting} mg/dL` : '~7 AM daily'} defaultValue={'avg'} data={[{ value: 'avg', label: avgFasting ? `Avg: ${avgFasting} mg/dL` : '~7 AM daily' }]} />
            </div>
          </div>

          {/* Use InfluxDB fasting data if available, otherwise fall back to old API */}
          {loadingInfluxRange ? <Loader /> : influxFastingData.length > 0 ? (
            <>
              <ResponsiveContainer width={'100%'} height={300}>
                <LineChart data={influxFastingData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis
                    axisLine={false}
                    tick={{ fill: '#111' }}
                    tickLine={false}
                    dataKey="day"
                    padding={{ left: 20, right: 20 }}
                    tickCount={15}
                    minTickGap={10}
                  />
                  <YAxis axisLine={false} tick={{ fill: '#111' }} tickLine={false} domain={['auto', 'auto']} minTickGap={20} tickCount={5} />
                  <Tooltip formatter={(value) => value ? `${value} mg/dL` : 'N/A'} />
                  <ReferenceArea y1={targetLower} y2={targetUpper} fill="#4CAF50" fillOpacity={0.15} />
                  <ReferenceLine y={targetLower} stroke="#4CAF50" strokeDasharray="5 5" label={{ value: String(targetLower), position: 'right', fill: '#4CAF50', fontSize: 10 }} />
                  <ReferenceLine y={targetUpper} stroke="#E53935" strokeDasharray="5 5" label={{ value: String(targetUpper), position: 'right', fill: '#E53935', fontSize: 10 }} />
                  <Line connectNulls allowDecimals={true} dot={true} isAnimationActive={false} activeDot={true} type="monotone" dataKey="blood_glucose_mg_per_dL" stroke="#0051A6" name='Fasting Glucose' />
                </LineChart>
              </ResponsiveContainer>
            </>
          ) : loaded === false ? <Loader /> : (
            <>
              <ResponsiveContainer width={'100%'} height={300}>
                <LineChart data={fastingChartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis
                    axisLine={false}
                    tick={{ fill: '#111' }}
                    tickLine={false}
                    dataKey="day"
                    padding={{ left: 20, right: 20 }}
                    tickCount={7}
                    minTickGap={10}
                  />
                  <YAxis axisLine={false} tick={{ fill: '#111' }} tickLine={false} domain={['auto', 'auto']} minTickGap={30} tickCount={7} />
                  <Tooltip />
                  <Line connectNulls allowDecimals={false} dot={true} isAnimationActive={false} activeDot={true} type="monotone" dataKey="blood_glucose_mg_per_dL" stroke="#0051A6" name='Glucose' />
                </LineChart>
              </ResponsiveContainer>
            </>
          )}
          <div className='chartlabel'>15 Days</div>
        </div>


        <div className='col-wrapper exercise' id='gcs4'>
          <div className='filter-wrapper'>

            <div className='left-div'><div className='total-cal dark-text'>Glucose - Daily Average</div>  </div>
            <div className='right-div'>
              <Select readOnly dropdownPosition="bottom" placeholder={avgDailyGlucose != null ? `Avg: ${avgDailyGlucose} mg/dL` : 'No data'} defaultValue={'avg'} data={[{ value: 'avg', label: avgDailyGlucose != null ? `Avg: ${avgDailyGlucose} mg/dL` : 'No data' }]} />
            </div>
          </div>

          {/* Use InfluxDB daily average if available, otherwise fall back to old API */}
          {loadingInfluxRange ? <Loader /> : influxDailyAvgData.length > 0 ? (
            <>
              <ResponsiveContainer width={'100%'} height={300}>
                <BarChart data={influxDailyAvgData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} dataKey="date" tickFormatter={(date) => moment(date, 'YYYY-MM-DD').format('M/D')} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={['auto', 'auto']} tickCount='5'  />
                  <Tooltip 
                    cursor={{ fill: 'transparent' }} 
                    formatter={(value, name) => [`${value} mg/dL`, name === 'glucose_avg' ? 'Average' : name]}
                    labelFormatter={(date) => moment(date, 'YYYY-MM-DD').format('ddd, MMM D')}
                  />
                  <ReferenceArea y1={targetLower} y2={targetUpper} fill="#4CAF50" fillOpacity={0.15} />
                  <ReferenceLine y={targetLower} stroke="#4CAF50" strokeDasharray="3 3" />
                  <ReferenceLine y={targetUpper} stroke="#E53935" strokeDasharray="3 3" />
                  <Bar type="monotone" dataKey="glucose_avg" fill="#18ACBC" barSize={15} name='Average' />
                </BarChart>
              </ResponsiveContainer>
              <div className='dayscroller'>15 Days</div>
            </>
          ) : loaded5 === false ? <Loader /> : (
            <>
              {Array.isArray(fortyday) ? (
                <ResponsiveContainer width={'100%'} height={300}><BarChart data={fortyday} margin={{ top: 5, right: 30, left: 20, bottom: 5, }} >
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} dataKey="date" tickFormatter={(date) => getLocalDayName(date)} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={['auto', 'auto']} tickCount='5'  />
                  <Tooltip cursor={{ fill: 'transparent' }} />
                  <Bar type="monotone" dataKey="glucose_avg" stroke="#18ACBC" barSize={15} name='Glucose' />
                </BarChart></ResponsiveContainer>

              ) : ''} {daysNav === '1' ? (<div className='dayscroller'><span className={selectedItem === 'first' ? 'active' : ''}><IconChevronLeft className='active' onClick={() => (nextPrev('last'), setSelected('last'))} /></span><span>Week</span><span className={selectedItem === 'last' ? 'active' : ''}><IconChevronRight className='active' onClick={() => (nextPrev('first'), setSelected('first'))} /></span></div>) : (<div className='dayscroller'>Week</div>)}
            </>
          )}

        </div>





        <div className='col-wrapper exercise' id='gcs5'>

          <div className='filter-wrapper'>
            <div className='left-div'><div className='total-cal dark-text'>Glucose Management Indicator (GMI) <br></br>  %</div>

            </div>
            <div className='right-div'>
              <Select readOnly dropdownPosition="bottom" placeholder={avgGmi != null ? `Avg: ${avgGmi}%` : 'No data'} defaultValue={'avg'} data={[{ value: 'avg', label: avgGmi != null ? `Avg: ${avgGmi}%` : 'No data' }]} />
            </div>
          </div>

          {/* Use InfluxDB-calculated GMI if available, otherwise fall back to old API */}
          {loadingInfluxRange ? <Loader /> : influxGmiData.length > 0 ? (
            <>
              <ResponsiveContainer width={'100%'} height={300}>
                <BarChart data={influxGmiData} margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis
                    axisLine={false}
                    tickLine={false}
                    tick={{ fill: '#111' }}
                    dataKey="day"
                    tickCount={15}
                    minTickGap={5}
                  />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={['auto', 'auto']} tickCount={7} minTickGap={2}  />
                  <Tooltip 
                    cursor={{ fill: 'transparent' }} 
                    formatter={(value) => value ? [`${value}%`, 'GMI'] : ['N/A', 'GMI']}
                  />
                  <ReferenceLine y={5.7} stroke="#4CAF50" strokeDasharray="3 3" label={{ value: 'Normal', position: 'right', fill: '#4CAF50', fontSize: 10 }} />
                  <ReferenceLine y={6.5} stroke="#FF9800" strokeDasharray="3 3" label={{ value: 'Pre-diabetic', position: 'right', fill: '#FF9800', fontSize: 10 }} />
                  <Bar barSize={15} dataKey="gmi" fill="#18ACBC" name='GMI' />
                </BarChart>
              </ResponsiveContainer>
              <div className='dayscroller'>15 Days</div>
            </>
          ) : loaded1 === false ? <Loader /> : (
            <>
              {Array.isArray(gmiChartData) ? (
                <ResponsiveContainer width={'100%'} height={300}>
                  <BarChart data={gmiChartData} margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
                    <CartesianGrid vertical={false} strokeDasharray="10 10" />
                    <XAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{ fill: '#111' }}
                      dataKey="day"
                      tickCount={7}
                      minTickGap={5}
                    />
                    <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={['auto', 'auto']} tickCount={7} minTickGap={2}  />
                    <Tooltip cursor={{ fill: 'transparent' }} />
                    <Bar barSize={15} dataKey="gmi" fill="#18ACBC" name='Glucose' />
                  </BarChart>
                </ResponsiveContainer>
              ) : ''} {daysNav1 === '1' ? (<div className='dayscroller'><span className={selectedItem1 === 'first' ? 'active' : ''}><IconChevronLeft className='active' onClick={() => (nextPrevGMI('last'), setSelected1('last'))} /></span><span>Week</span><span className={selectedItem1 === 'last' ? 'active' : ''}><IconChevronRight className='active' onClick={() => (nextPrevGMI('first'), setSelected1('first'))} /></span></div>) : (<div className='dayscroller'>Week</div>)}
            </>
          )}

        </div>



        <div className='col-wrapper exercise' id='gcs6'>
          <div className='filter-wrapper'>

            <div className='left-div'><div className='total-cal dark-text'>Average Glucose - Day Details</div>

            </div>
            <div className='right-div'>

              <Select data={data} defaultValue={defaultDate.toString()} onChange={(val) => { setDay(val) }} />
            </div>
          </div>

          {/* Use InfluxDB 3-hour averages if available, otherwise fall back to old API */}
          {loadingDayDetails ? <Loader /> : influxDayDetailsData.length > 0 ? (
            <>
              <ResponsiveContainer width={'100%'} height={300}>
                <BarChart data={influxDayDetailsData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis 
                    axisLine={false} 
                    tickLine={false} 
                    tick={{ fill: '#111' }} 
                    dataKey="time" 
                    tickFormatter={(time) => {
                      // Convert "0to3" to "12-3 AM" format
                      const parts = time.replace('to', '-').split('-');
                      const start = parseInt(parts[0]);
                      const end = parseInt(parts[1]);
                      const formatHour = (h) => h === 0 ? '12' : h > 12 ? h - 12 : h;
                      return `${formatHour(start)}-${formatHour(end)}`;
                    }} 
                  />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={[0, 'auto']} tickCount='5'  />
                  <Tooltip 
                    cursor={{ fill: 'transparent' }} 
                    formatter={(value) => value ? [`${value} mg/dL`, 'Average'] : ['N/A', 'Average']}
                    labelFormatter={(time) => {
                      const parts = time.replace('to', '-').split('-');
                      const start = parseInt(parts[0]);
                      const end = parseInt(parts[1]);
                      const period = (h) => h < 12 ? 'AM' : 'PM';
                      const formatHour = (h) => h === 0 ? 12 : h > 12 ? h - 12 : h;
                      return `${formatHour(start)} ${period(start)} - ${formatHour(end)} ${period(end)}`;
                    }}
                  />
                  <ReferenceArea y1={targetLower} y2={targetUpper} fill="#4CAF50" fillOpacity={0.15} />
                  <ReferenceLine y={targetLower} stroke="#4CAF50" strokeDasharray="3 3" />
                  <ReferenceLine y={targetUpper} stroke="#E53935" strokeDasharray="3 3" />
                  <Bar dataKey="glucose_avg" fill="#18ACBC" barSize={15} name='Glucose' />
                </BarChart>
              </ResponsiveContainer>
            </>
          ) : loaded6 === false ? <Loader /> : (
            <>
              {Array.isArray(rangeAveDay) && rangeAveDay?.[0]?.[day - 1]?.full_day_data ? (
                <ResponsiveContainer width={'100%'} height={300}><BarChart data={rangeAveDay[0][day - 1].full_day_data} margin={{ top: 5, right: 30, left: 20, bottom: 5, }} >
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} dataKey="time" tickFormatter={(time) => { var a = (time.replace(/[to]/g, '')).replace('__', '-'), b = moment(a.split('-')[1], 'Hh').format('h'), c = moment(a.split('-')[0], 'Hh').format('h'); return c + '-' + b }} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={[0, 'auto']} tickCount='5'  />
                  <Tooltip cursor={{ fill: 'transparent' }} />
                  <Bar type="monotone" dataKey="glucose_avg" stroke="#18ACBC" barSize={15} name='Glucose' />
                </BarChart></ResponsiveContainer>
              ) : (<>
                <ResponsiveContainer width={'100%'} height={300}><BarChart margin={{ top: 5, right: 30, left: 20, bottom: 5, }} >
                  <CartesianGrid vertical={false} strokeDasharray="10 10" />
                  <XAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} data={['12-3', '3-6', '6-9', '9-12', '12-3', '3-6', '6-9', '9-12']} domain={['12-3', '3-6', '6-9', '9-12', '12-3', '3-6', '6-9', '9-12']} tickCount='8' ticks={['12-3', '3-6', '6-9', '9-12', '12-3', '3-6', '6-9', '9-12']} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fill: '#111' }} domain={[0, 'auto']} tickCount='5'  />
                  <Tooltip cursor={{ fill: 'transparent' }} />
                  <Bar type="monotone" dataKey="glucose_avg" stroke="#18ACBC" barSize={15} name='Glucose' />
                </BarChart></ResponsiveContainer>
              </>)}
            </>
          )}

        </div>

        {/* AGP Chart - Full Width */}
        <AGPChart />

        {/* Daily Glucose Profiles - Full Width - COMMENTED OUT FOR PERFORMANCE TESTING */}
        {/* <DailyGlucoseProfiles /> */}

      </div>
    </div>


  );
}

export default Userglucose;
